(function(){
'use strict';
var GN=9.81;
var BOFF_A=0.020; // A bearing shoe = 20mm fixed always
// Finer force catalog than a typical single Stabilus line, deliberately: coarse steps (the old
// list jumped 100→150, a 50% increase) forced large force overshoot whenever the exact required
// force landed just above a step, which in turn made the strut kick in far earlier than the
// angle requested. Finer steps let the solver get much closer to the actual target.
// Gas struts are a continuous product, not a fixed parts list: any extended length in 5mm
// increments, any force in 5N increments, within the shaft's real envelope (see calcP below).
// Only the NZ-made Struxa alternative (STRUXA further down) is an actual fixed-size product.
// Verified via a Node.js sweep (1,120 combinations of weight/length/thickness/kick-in target)
// that top_hinge has no real bind/over-extension/no-fit failures at 90°, same as the other two
// types — the old 70° cap here was an arbitrary UI limit, not a physical one.
var TMMAX={box_lid:90,top_hinge:90,bottom_hinge:90};
// Real Struxa (NZ-made) stock list — replaces an earlier, incomplete 14-length guess. Flat
// $75 incl GST per 8mm-shaft unit. The 10mm/648mm line is withdrawn - not listed (per the actual price
// list — the old per-length STRX_P table, which varied $62–$86, was not real pricing). Stock
// qty of 0 means pre-order, not unavailable — struxaOk below no longer requires qty>0, but the
// product note flags pre-order vs in-stock so the customer knows what to expect.
// 01/10/2026: this list is now the SELLABLE lengths, not the supplier price list.
// Counted off the live catalogue (products.json, SKU STRUT-8-*): products/8mm-gas-strut
// carries 16 length variants. The previous 25-length list came from a price list, and
// nine of those lengths have no variant at all - the default inputs recommended 455mm,
// which cannot be bought at any price. Jay's design notes for the new UI also say
// "the chip grid of 16 lengths", which agrees.
// Dropped (no variant): 325, 405, 435, 455, 475, 485, 505, 515, 535.
// Put one back only when it exists as a variant, or the cart dead-ends again.
// qty 0 = pre-order, not unavailable: 575 is a real variant that is currently out
// of stock, so it stays in the list and shows the pre-order note.
var STRUXA_STOCK={280:20,300:20,320:20,330:30,375:4,440:20,460:20,480:30,500:40,520:40,540:20,555:16,560:20,575:0,580:20,585:14};
var STRUXA=Object.keys(STRUXA_STOCK).map(Number);
var STRUXA10_STOCK={};  // Struxa does not list a 10mm shaft (07/09/2026). Empty on purpose:
                        // STOCK_CANDS then offers no 10mm Struxa length, struxaOk can never be
                        // true for shD===10, and PSTRX10 is unreachable. The 10mm shaft maths
                        // below is left alone - it sizes imported struts, not Struxa ones.
var STRUXA10=Object.keys(STRUXA10_STOCK).map(Number);
var P8=78,P10=98;          // Stabilus (imported) pricing — unchanged
var PSTRX8=75,PSTRX10=80;  // Struxa (NZ-made) flat pricing incl. GST. 8mm went 68 -> 75 on 07/09/2026.
var S={type:'box_lid',w:8,l:500,wd:600,t:18,bh:300,ns:2,oa:90,soa:20,tilt:0,ang:0,hingem:'flush'};
var P=null,playing=false,aTimer=null,aDir=1,pBrand='strx',pQty=2; // Struxa-branded page: default to the native brand
// ─── PHYSICS ──────────────────────────────────────────────────────────────────
// Design philosophy (all three panel types share it):
//  1. Bracket positions are chosen from a STABLE, physically-motivated relationship (like an
//     installer would pick), not reverse-solved from whatever catalog part happens to fit —
//     that used to make the recommended bracket position jump by 50-100mm for a 10mm change
//     in panel size. Here we still search the whole catalog, but among every candidate that
//     validates, we keep whichever leaves the bracket closest to a smooth reference curve, so
//     dimensions changing gradually move the bracket gradually too.
//  2. Every candidate is validated across the FULL sweep of motion (every degree from closed
//     to open), not just the two endpoints — a strut can bind or lose mechanical advantage
//     partway through a swing even when both ends look fine.
//  3. Required force is sized to the WORST angle across the entire "must hold open" range
//     [kick-in angle, max open angle], not just exactly at the kick-in angle. For box lids
//     gravity's closing torque is highest right at the kick-in angle so this rarely changes
//     anything, but for outward-opening windows/hatches gravity's resistance keeps *growing*
//     as they open further, so sizing only for the kick-in angle could leave the strut too
//     weak to hold the panel near fully open — it would sag back. This guarantees it never does.
function r5(v){return Math.round(v/0.005)*0.005;} // round to nearest 5mm

function calcP(){
  var tp=S.type,Wn=S.w*GN,L=S.l/1000,BH=Math.max(100,S.bh)/1000,T=S.t/1000;
  var ns=S.ns,oa=S.oa,tiltR=(S.tilt||0)*Math.PI/180;
  var a=r5(L*0.65);    // 65% of lid depth from hinge — same rule for every type
  var Bx,By,recF=null,recLen=null,compLen=null,noFit=false,prot=null;
  // Hinge mount type (box_lid only): all the bracket-position math below solves everything
  // relative to the hinge PIVOT, which is correct regardless of hardware — moving the wall
  // doesn't move the lid's center of mass relative to the pivot, so it never changes the
  // recommended force or kick-in angle. What it DOES change is where the true back-wall face
  // sits relative to that pivot, which only matters for the "B forward from back wall" number
  // and the diagram. "Flush/piano hinge" assumes the pivot sits right at the wall's inner
  // corner (0 offset — this was the only behaviour before this control existed). "Inside face"
  // mounts move the pivot forward of the true wall by roughly one panel-thickness (using lid
  // thickness as a stand-in for wall thickness, since box lids/walls are commonly the same
  // material) — the true wall is further back than assumed, so B reads further forward from it.
  // "Overlay" (hinge strap on top of the wall) keeps its barrel essentially at the same inner
  // corner horizontally, so it's treated the same as flush here.
  var hingeOff=(tp==='box_lid'&&S.hingem==='inside')?T:0;

  // Kinematics for each panel type: where A (the panel-side ball) sits at swing angle θ, and
  // the gravity torque about the hinge at that angle. tiltR shifts the whole gravity curve to
  // model the box itself sitting on a slope (box_lid only; tiltR is 0 for the others).
  function Ax_(θ){return tp==='box_lid'?a*Math.cos(θ)+BOFF_A*Math.sin(θ):a*Math.sin(θ);}
  function Ay_(θ){
    if(tp==='box_lid') return a*Math.sin(θ)-BOFF_A*Math.cos(θ);
    return tp==='top_hinge'? -a*Math.cos(θ) : a*Math.cos(θ);
  }
  function tor_(θ){
    if(tp==='box_lid') return Wn*(L/2)*Math.cos(θ+tiltR);
    return Wn*(L/2)*Math.sin(θ);
  }

  // This is a Struxa-only page: unlike a continuous catalog, Struxa is a real, fixed-size
  // stock product — every recommendation MUST be one of the actual STRUXA/STRUXA10 lengths,
  // never an arbitrary solved length. So instead of solving for an ideal length and rounding,
  // we solve for the ideal bracket position once, then test the ACTUAL stock lengths in order
  // of how close they land to that ideal spot, and return the first one that's geometrically
  // valid (won't bind or over-extend across the full sweep) AND has enough force headroom for
  // its shaft size. If none of the stock lengths work, that's a genuine no-fit — this page
  // should never quietly recommend a length we don't actually stock.
  var STOCK_CANDS=STRUXA.map(function(l){return{Lx:l,shD:8};}).concat(STRUXA10.map(function(l){return{Lx:l,shD:10};}));
  function solveStruxa(idealFree,solveFree,invertFree,fixedOf,boundsOk){
    var Lx0=invertFree(idealFree);
    if(Lx0==null||!isFinite(Lx0)) return null;
    var cands=STOCK_CANDS.slice().sort(function(a,b){return Math.abs(a.Lx-Lx0)-Math.abs(b.Lx-Lx0);});
    for(var ci=0; ci<cands.length; ci++){
      var Lx=cands[ci].Lx,shD=cands[ci].shD;
      // Compressed length vs. extended (installation) length — calibrated from real measured
      // pairs (505mm install/210mm stroke, 585mm/252mm, 375mm/147mm — i.e. compressed lengths
      // of 295, 333, 228mm). cL = 0.5*Lx + 40.5 fits all three within 2mm.
      var cL=Math.round(0.5*Lx+40.5);
      var free=solveFree(Lx,cL);
      if(free==null||!boundsOk(free)) continue;
      var pt=fixedOf(free),mnSep=1e9,mxSep=0;
      for(var dd=0;dd<=oa;dd++){
        var θdd=dd*Math.PI/180;
        var ddx=pt.x-Ax_(θdd),ddy=pt.y-Ay_(θdd),sldmm=Math.sqrt(ddx*ddx+ddy*ddy)*1000;
        if(sldmm<mnSep)mnSep=sldmm;
        if(sldmm>mxSep)mxSep=sldmm;
      }
      if(mnSep<cL+3) continue;  // would bind mid-travel (3mm margin for degree-step sampling)
      if(mxSep>Lx) continue;    // would over-extend mid-travel
      var Freq=sizeForce(pt);
      if(!(Freq>0&&isFinite(Freq))) continue;
      var F=roundForce(Freq);
      if(F>(shD===10?F_MAX10:F_MAX8)) continue; // this stock length can't provide enough force
      return {Lx:Lx,cL:cL,free:free,pt:pt,shD:shD,F:F};
    }
    return null;
  }

  // Force big enough to hold at every angle from the kick-in angle to fully open, not just
  // exactly at the kick-in angle (see note 3 above).
  function sizeForce(pt){
    var need=0;
    for(var dd=S.soa; dd<=oa; dd++){
      var θdd=dd*Math.PI/180;
      var Axd=Ax_(θdd),Ayd=Ay_(θdd);
      var ddx=pt.x-Axd,ddy=pt.y-Ayd,l=Math.sqrt(ddx*ddx+ddy*ddy);
      var arm=l>1e-6?Math.abs(Axd*pt.y-Ayd*pt.x)/l:0;
      if(arm>1e-4){
        var f=tor_(θdd)/(ns*arm);
        if(f>need) need=f;
      }
    }
    return need;
  }

  // Force ceilings for each shaft size (used above to reject a stock length that's geometrically
  // fine but mechanically undersized) — 8mm shafts top out around 700N, 10mm around 2000N.
  // 8mm was capped at 700N here, but the live product form caps
// properties[_Pressure (N)] at 650 and refuses to submit above it, so a 700N
// recommendation could not actually be ordered. 650 is the real ceiling.
// The 10mm figure is left alone - it sizes imported struts, not Struxa ones.
var F_MIN=50,F_MAX8=650,F_MAX10=2000;
  function roundForce(f){return Math.max(F_MIN,Math.ceil(f/5)*5);}

  var idealFree,solveFree,invertFree,fixedOf,boundsOk,D,dlt,Bxc,sign;
  if(tp==='box_lid'){
    // D = B below hinge — FIXED at 70mm for all practical boxes (BH ≥ 234mm), scaling down
    // for shallow boxes so B stays inside the box. Bx (forward from the hinge) is the free
    // coordinate solved for.
    D=Math.max(r5(Math.min(0.070,BH*0.30)),0.030);
    dlt=D-BOFF_A;
    solveFree=function(Lx,cL){
      var hyp=(cL+12)/1000;
      if(hyp*hyp<=dlt*dlt) return null;
      return a-Math.sqrt(hyp*hyp-dlt*dlt);
    };
    invertFree=function(freeVal){
      var X=a-freeVal; if(X<0) return null;
      var hyp=Math.sqrt(X*X+dlt*dlt);
      return (hyp*1000-12)/0.57;
    };
    fixedOf=function(bx){return {x:bx,y:-D};};
    boundsOk=function(bx){return bx>=0.015&&bx<=a*0.88;};
    idealFree=r5(0.18*a);
  } else {
    // Outward-opening top-hung window or bottom-hung hatch. Closed position hangs/stands
    // straight along the hinge axis (A0 = (0,∓a)); B (the frame bracket) is set BACK behind
    // the hinge line — this is required, not cosmetic. If B sat on the same side as A's travel,
    // the hinge–A–B line goes collinear at some angle mid-swing (a linkage "dead point"),
    // driving the mechanical arm to zero right where the strut also happens to be shortest —
    // i.e. it would try to bind. By (how far above/below the hinge B sits) is the free
    // coordinate solved for; Bx (the standoff behind the hinge) is fixed by how much clearance
    // the panel thickness needs.
    sign=tp==='top_hinge'?-1:1;
    dlt=Math.max(0.030,Math.min(0.060,T+0.025));
    Bxc=-dlt;
    solveFree=function(Lx,cL){
      var hyp=(cL+12)/1000;
      if(hyp*hyp<=dlt*dlt) return null;
      return sign<0 ? -a+Math.sqrt(hyp*hyp-dlt*dlt) : a-Math.sqrt(hyp*hyp-dlt*dlt);
    };
    invertFree=function(freeVal){
      var X=sign<0?(freeVal+a):(a-freeVal); if(X<0) return null;
      var hyp=Math.sqrt(X*X+dlt*dlt);
      return (hyp*1000-12)/0.57;
    };
    fixedOf=function(byv){return {x:Bxc,y:byv};};
    boundsOk=function(byv){return sign<0?(byv<=0&&byv>=-a):(byv>=0&&byv<=a);};
    idealFree=sign*0.36*a;
  }

  var best=solveStruxa(idealFree,solveFree,invertFree,fixedOf,boundsOk);
  var shD=8;
  if(best){
    // best.F/best.shD were already validated against that shaft's force ceiling inside
    // solveStruxa, and best.free is the exact solved bracket position the bind/over-extend/
    // force checks were computed at — using it unrounded keeps those checks valid.
    shD=best.shD;
    if(tp==='box_lid'){Bx=best.free;By=-D;} else {Bx=Bxc;By=best.free;}
    recF=best.F;recLen=best.Lx;compLen=best.cL;prot=12;
  }
  if(recF==null){
    noFit=true;
    if(tp==='box_lid'){Bx=r5(0.18*a);By=-D;} else {Bx=Bxc;By=idealFree;}
    recF=F_MAX10;recLen=null;compLen=null;prot=null;shD=10;
  }

  // Full-sweep simulation used for the live readouts, graph, and animation.
  var data=[],mnS=1e9,mxS=0;
  for(var d=0;d<=oa;d++){
    var θd=d*Math.PI/180,Ax=Ax_(θd),Ay=Ay_(θd),tor=tor_(θd);
    var ddx=Bx-Ax,ddy=By-Ay,sl=Math.sqrt(ddx*ddx+ddy*ddy);
    var arm=sl>1e-4?Math.abs(Ax*ddy-Ay*ddx)/sl:0;
    data.push({d:d,sl:sl,tor:tor,arm:arm});
    if(sl*1000<mnS)mnS=sl*1000;if(sl*1000>mxS)mxS=sl*1000;
  }
  var totF=(recF||0)*ns,soAng=null;
  for(var j=0;j<data.length;j++){if(data[j].tor>0.05&&totF*data[j].arm>=data[j].tor){soAng=data[j].d;break;}}
  var stroke=recLen?recLen-(compLen||0):Math.round(mxS-mnS);
  var tubeOD=shD===10?28:20,tubeR=tubeOD/2;
  var stoff=shD===10?20:15;
  var struxaOk=recLen&&((shD===8&&STRUXA.indexOf(recLen)>=0)||(shD===10&&STRUXA10.indexOf(recLen)>=0));
  var struxaStock=recLen?(shD===10?STRUXA10_STOCK[recLen]:STRUXA_STOCK[recLen]):null;
  var f2cl=Bx&&recF?Math.round(ns*recF*Bx/L):0;
  // arm at θ=0 (closed) via the same cross-product formula used throughout the sweep —
  // correct for all three panel types, no per-type approximation needed.
  var arm0lf=(data[0]&&data[0].sl>1e-4)?data[0].arm:0;
  var latchF=Math.max(0,Math.round(((recF||0)*ns*arm0lf-Wn*L/2)/(L/2)));
  return{data:data,recF:recF,mnS:mnS,mxS:mxS,recLen:recLen,compLen:compLen,
    stroke:stroke,noFit:noFit,prot:prot,soAng:soAng,f2:f2cl,latchF:latchF,
    L:L,BH:BH,a:a,Bx:Bx,By:By,D:Math.abs(By),hingeOff:hingeOff,
    shD:shD,tubeOD:tubeOD,tubeR:tubeR,stoff:stoff,struxaOk:struxaOk,struxaStock:struxaStock};
}
// ─── HELPERS ──────────────────────────────────────────────────────────────────
function E(id){return document.getElementById(id);}
function sv(id,v,mn,mx){var p=Math.max(0,Math.min(100,((+v-mn)/(mx-mn))*100));var f=E('f-'+id),h=E('h-'+id);if(f)f.style.width=p+'%';if(h)h.style.left=p+'%';}
// ─── PRODUCT ──────────────────────────────────────────────────────────────────
// Struxa-only page: no brand toggle — every recommendation is drawn from the real Struxa
// stock list (see calcP), so the product card always shows Struxa, at flat Struxa pricing.
// ─── STRUXA CART ──────────────────────────────────────────────────────────────
// products/8mm-gas-strut carries one variant per stock length and two required line
// item properties. Read off the live product page 01/10/2026 - the End Fittings
// strings must match its <option> text exactly or the order line is wrong.
// Declared here, at top level, not beside F_MAX8 - that sits inside a function
// scope, so sxCartUrl below could not see these and threw ReferenceError on
// every call, silently leaving the product card half-updated.
var SX_FORCE_MIN=100,SX_FORCE_MAX=650,SX_FORCE_STEP=10;
var SX_VARIANTS={280:48773153128548,300:48773153161316,320:48773153194084,
  330:48773153259620,375:48773153292388,440:48773153390692,460:48773153456228,
  480:48773153521764,500:48773153587300,520:48773153685604,540:48773153751140,
  555:48773153783908,560:48773153816676,575:48773153849444,580:48773153882212,
  585:48773153914980};
function sxCartUrl(len,force,qty,fitting){
  var vid=SX_VARIANTS[len];
  if(!vid)return null;                       // length we do not actually sell
  var f=Math.round(force/SX_FORCE_STEP)*SX_FORCE_STEP;   // form uses step 10
  f=Math.max(SX_FORCE_MIN,Math.min(SX_FORCE_MAX,f));
  return 'https://struxamotion.com/cart/add?id='+vid
    +'&quantity='+(qty||1)
    // Private line item property. The underscore is Shopify's own
    // convention: hidden from the cart, the checkout and the customer's
    // email, still on the order and still in the admin. The force is
    // ours; the picker needs it; the buyer does not get it.
    +'&properties'+encodeURIComponent('[_Pressure (N)]')+'='+encodeURIComponent(f)
    +'&properties'+encodeURIComponent('[End Fittings]')+'='+encodeURIComponent(fitting);
}
// Nearest sellable lengths either side of the recommendation. Reference only -
// the point of the card is that we computed one answer, not that you browse.
function updAlts(len){
  var row=E('altrow');if(!row)return;
  if(!len){row.innerHTML='';return;}
  var all=STRUXA.slice().sort(function(a,b){return a-b;});
  var i=all.indexOf(len),out=[];
  if(i>0)out.push(all[i-1]);
  if(i>=0&&i<all.length-1)out.push(all[i+1]);
  row.innerHTML=out.map(function(l){
    var q=STRUXA_STOCK[l];
    return '<div class="alt"><div class="alt-l">'+l+'mm</div><div class="alt-s">'+
      (l<len?'shorter':'longer')+' \u00b7 '+(q>0?'in stock':'pre-order')+'</div></div>';
  }).join('');
}
function updChips(len){
  var g=E('chipgrid');if(!g)return;
  g.innerHTML=STRUXA.slice().sort(function(a,b){return a-b;}).map(function(l){
    var q=STRUXA_STOCK[l];
    return '<div class="chip'+(l===len?' on':'')+(q>0?'':' out')+'" title="'+
      (q>0?q+' in stock':'pre-order')+'">'+l+'</div>';
  }).join('');
}
function updProd(){
  var p=P;if(!p)return;
  var F=p.recF||0,Lx=p.recLen||0,sd=p.shD;
  var pEach=sd===10?PSTRX10:PSTRX8,tot=pEach*pQty;
  var dot=E('psvgdot');if(dot)dot.setAttribute('fill','#ff7a00');
  E('pname').innerHTML='Struxa Gas Strut<span class="sbg '+(sd===8?'s8':'s10')+'">Ø'+sd+'mm</span>';
  // Show strut size and shaft for customer — force N is a technical detail handled by the kick-in slider
  E('pspec').textContent=Lx+'mm extended · '+(p.compLen||'?')+'mm compressed · Ø'+sd+'mm';
  E('qnum').textContent=pQty;
  E('pval').textContent=tot?'$'+tot.toFixed(2):'—';
  E('psub').textContent='NZ$ incl. GST · '+pQty+' unit'+(pQty>1?'s':'')+(pEach?' ($'+pEach+'/ea)':'');
  // Point Add to Cart at the real Struxa product, carrying the calculated force.
  // If the solver lands on a length we do not stock, fall back to the product page
  // rather than building a cart URL for a variant that does not exist.
  var cb=E('cartbtn');
  cb.className='cb2 cbsx';
  var fitEl=E('sxfit');
  var fitting=fitEl?fitEl.value:'Standard Plastic Socket 10mm (both ends)';
  var url=(!p.noFit&&Lx)?sxCartUrl(Lx,F,pQty,fitting):null;
  cb.href=url||'https://struxamotion.com/products/8mm-gas-strut';
  _prevLen=(!p.noFit&&Lx)?Lx:null;updStrutImg();
  cb.textContent=url?'\u{1F6D2} Add to Cart':'\u{1F6D2} View gas struts';
  // Struxa is a real, fixed-size stock item — tell the customer plainly whether this exact
  // length is on the shelf or needs a pre-order, rather than implying every size ships same-day.
  var stockNote=p.recLen?((p.struxaStock>0)?' · ✓ In stock ('+p.struxaStock+')':' · Pre-order item — please confirm lead time'):'';
  E('pnote').textContent='Installer spec: '+F+'N × '+pQty+stockNote;
  E('prod-area').style.opacity=p.noFit?0.4:1;
  // --- design fields: make the result read as something we WORKED OUT -------
  var strokeMm=(Lx&&p.compLen)?(Lx-p.compLen):null;
  E('plen').textContent=Lx?Lx+'mm':'-';
  E('psku').textContent=Lx?('SKU STRUT-8-'+Lx):'\u00a0';
  E('kv-len').innerHTML=Lx?(Lx+' <i>mm</i>'):'-';
  E('kv-str').innerHTML=strokeMm?(strokeMm+' <i>mm</i>'):'-';
  E('kv-kick').innerHTML=(p.soAng!==null&&p.soAng!==undefined)?(p.soAng+'<i>&deg;</i>'):'-';
  E('pstock').textContent=p.noFit?'No standard fit':((p.struxaStock>0)?'In stock \u00b7 ships from NZ':'Pre-order \u00b7 made to order');
  E('pcalc').textContent=p.noFit?'\u00a0':('Calculated for your '+S.l+' x '+S.wd+'mm panel at '+S.oa+' degrees, '+S.w+'kg, on '+pQty+' strut'+(pQty>1?'s':'')+'.');
  updAlts(Lx);updChips(Lx);
}
// ─── FAST UPDATE — textContent only, zero reflow ─────────────────────────────
function updFast(){
  var p=P,tp=S.type,deg=S.ang,oa=S.oa;
  var cur=p.data[Math.min(deg,p.data.length-1)]||{tor:0,arm:0,sl:0};
  var isSO=p.soAng!==null&&deg>=p.soAng,so=p.soAng!==null?p.soAng:oa;
  E('hv').textContent=p.noFit?'⚠ No fit':(p.recLen||'?')+' mm';
  E('hs').textContent=p.noFit?'Adjust kick-in angle':(p.recLen||'?')+' mm ext · Ø'+(p.shD||'?')+'mm · kicks in at '+(p.soAng!==null?p.soAng+'°':'—');
  // Mounting positions (stable, display in mm) — labels switch per panel type since the
  // bracket geometry genuinely differs (box_lid has a 20mm offset arm on both A and B; the
  // window/hatch types mount both balls with no separate arm, just the frame standoff).
  var isBox=tp==='box_lid';
  E('r-a').textContent=Math.round(p.a*1000)+' mm ('+(isBox?'65% of lid depth':'65% of panel depth')+', 20mm arm)';
  if(isBox){
    // p.hingeOff shifts where the TRUE wall face sits relative to the pivot the rest of the
    // math is solved from (see calcP) — it never changes the recommended strut/force, only
    // this displayed distance and the note below.
    E('ml-bf').textContent='Bracket B in from the hinge wall';
    E('r-bf').textContent=Math.round((p.Bx+(p.hingeOff||0))*1000)+' mm ('+p.stoff+'mm standoff off wall)';
    E('ml-bd').textContent='Bracket B offset off the hinge line';
    E('r-bD').textContent=Math.round((p.D||0.070)*1000)+' mm';
    E('stoff-ab').textContent=p.stoff+'mm standoff keeps the strut tube clear of the wall as it swings';
    var abL=E('ab-legend');if(abL)abL.innerHTML='<b style="color:#ff7a00">A</b> = bearing shoe on lid (20mm arm) · <b style="color:#1c1e22">B</b> = side bracket on wall ('+p.stoff+'mm standoff)';
    var lfLbl=E('lf-label');if(lfLbl)lfLbl.textContent='Strut horizontal at close → latch force';
  } else {
    E('ml-bf').textContent='Bracket B set back from the hinge line';
    E('r-bf').textContent=Math.round(Math.abs(p.Bx)*1000)+' mm';
    E('ml-bd').textContent='Bracket B '+(tp==='top_hinge'?'below':'above')+' the hinge';
    E('r-bD').textContent=Math.round((p.D||0.070)*1000)+' mm';
    E('stoff-ab').textContent='Bracket set back '+Math.round(Math.abs(p.Bx)*1000)+'mm from the hinge line, clearing the panel as it swings';
    var abL2=E('ab-legend');if(abL2)abL2.innerHTML='<b style="color:#ff7a00">A</b> = ball mounted on panel (no offset) · <b style="color:#1c1e22">B</b> = ball mounted on frame jamb';
    var lfLbl2=E('lf-label');if(lfLbl2)lfLbl2.textContent='Force needed just to hold panel shut/closed';
  }
  // "Kicks in at" is purely a readout now, not a dial-in target — it just reports the earliest
  // angle the recommended strut can actually hold the lid open on its own (there's no separate
  // "target" any more to disagree with it). For an outward-opening window/hatch, gravity offers
  // ZERO resistance exactly at closed (hanging/standing straight, like a pendulum at rest) and
  // only grows from there, so any strut with a real mechanical arm engages almost immediately —
  // verified numerically across a wide sweep, the self-opens angle stays ~1° for these two types
  // regardless of the panel/weight, since it's a fact of the geometry, not something to size for.
  var mlSo=E('ml-so'),kiSub=E('ki-sub');
  if(isBox){
    if(mlSo)mlSo.textContent='Strut kicks in at';
    if(kiSub)kiSub.innerHTML='Lift to this angle, release — lid holds open on its own.';
  } else {
    if(mlSo)mlSo.textContent='Self-opens from';
    if(kiSub)kiSub.innerHTML='Engages almost immediately once you start opening it — gravity offers no resistance right at closed, unlike a lid, so the strut takes over within a degree or two.<br>It\'s sized to safely hold the panel open at every angle up to Max Open Angle.';
  }
  // Latch force
  var lf=p.latchF||0,lfEl=E('lf-val');
  if(lfEl){
    lfEl.textContent=lf<=0?'Zero ✓ — gravity holds it shut':lf+'N';
    lfEl.style.color=lf<=0?'#8a8a86':lf<25?'#8a8a86':'#fbbf24';
  }
  // Zone bar
  E('zrl').textContent='0–'+so+'°';E('zgl').textContent=so+'–'+oa+'°';
  E('zr').style.flex=so;E('zg').style.flex=Math.max(1,oa-so);
  // Kick-in display (primary customer-facing indicator)
  var kiEl=E('ki-disp');
  if(kiEl) kiEl.textContent=p.soAng!==null?p.soAng+'°':'—';
  // Thumb jumps straight to the achieved angle (0..oa) — see the read-only <div> note in the
  // HTML above for why there's no real <input range> under it.
  sv('soa',p.soAng!==null?p.soAng:0,0,Math.max(1,oa));
  var soTxt=p.soAng===null?'No fit':p.soAng===0?'Immediately':p.soAng+'°';
  E('r-so').textContent=soTxt;E('r-so').style.color=p.soAng!==null?'#8a8a86':'#8a8a86';
  E('r-sos').textContent=p.soAng===null?'Adjust settings':(isBox?('lift to '+p.soAng+'°, release — holds open'):'holds open at every angle from here on');
  // Closing effort
  var dOa=p.data[Math.min(S.oa,p.data.length-1)]||{tor:0,arm:0};
  var sTorOa=(p.recF||0)*S.ns*dOa.arm;
  var closeFv=Math.round(Math.max(0,sTorOa-dOa.tor)/(p.L||0.5));
  E('r-f2').textContent=closeFv+' N';
  E('r-f2s').textContent='push down from '+S.oa+'° — lid weight assists';
  // Slam risk
  var soA=p.soAng||10;
  var midIdx=Math.max(1,Math.min(Math.round(soA/2),p.data.length-1));
  var dMid=p.data[midIdx]||{tor:0,arm:0};
  var sTorMid=(p.recF||0)*S.ns*dMid.arm;
  var netC=Math.max(0,dMid.tor-sTorMid);
  var slamF=Math.round(netC/(p.L||0.5));
  var slamPct=S.w>0?Math.round(slamF/(S.w*GN)*100):0;
  var sbox=E('slambox');
  if(sbox){
    sbox.textContent=slamPct<15?'✓ Gentle closing — low slam risk below '+soA+'°':slamPct<40?'Moderate closing speed below '+soA+'° — guide the last degrees gently':'⚠ High slam risk below '+soA+'° — consider a lower kick-in setting';
    sbox.className='slambox '+(slamPct<15?'slam-ok':slamPct<40?'slam-warn':'slam-bad');
  }
  // Hand force (correct formula)
  var sTorCur=(p.recF||0)*S.ns*cur.arm;
  var hfCur=Math.round(Math.abs(cur.tor-sTorCur)/(p.L||0.5));
  var hfDir=cur.tor>sTorCur?'↑ push open':'↓ push closed';
  E('ll').textContent=hfCur===0?'0 N balanced':(hfCur+' N '+hfDir);
  E('adeg').textContent=deg+'°';
  // Figure annotation, the way the design labels its drawings: what the view is
  // showing right now, and the box it was solved for.
  var tName=tp==='box_lid'?'Box lid':'Window';
  var fs=E('fig2-state');if(fs)fs.textContent=tName+' · open '+deg+'°';
  var ff=E('fig2-foot');if(ff)ff.textContent='Box '+S.l+' × '+S.wd+' × '+S.bh+
    '   ·   '+(S.ns===1?'One strut':'Two struts');
  sv('ang',deg,0,oa);var sa=E('s-ang');if(sa){sa.max=oa;sa.value=deg;}
  var pill=E('pill');
  if(!p.recF){pill.textContent='No fit';pill.className='pi pi-no';}
  else if(p.soAng===null){pill.textContent='Manual only';pill.className='pi pi-no';}
  else if(isSO){pill.textContent='✓ Holds open';pill.className='pi pi-ok';}
  else if(deg===0){pill.textContent='Latch zone';pill.className='pi pi-no';}
  else{pill.textContent='Lift to '+p.soAng+'°';pill.className='pi pi-no';}
  var isLight=S.w<=5;
  E('nb1').disabled=!isLight;E('nb1').style.opacity=isLight?1:0.25;
  if(!isLight&&S.ns===1){S.ns=2;E('nb1').classList.remove('on');E('nb2').classList.add('on');}
  E('nsnote').textContent=isLight?'1 strut OK for panels ≤5 kg':'2 struts required for panels over 5 kg';
  pQty=Math.max(S.ns,pQty);
}
// ─── SETTLED UPDATE ──────────────────────────────────────────────────────────
function updSettled(){
  var p=P;
  E('nfw').style.visibility=p.noFit?'visible':'hidden';
  if(p.noFit)E('nfm').textContent='No standard strut fits — lower kick-in or adjust dimensions.';
  updProd();
  drawDiag();
  if(_curView==='gr') drawGraph();
}
// ─── INSTALLATION DIAGRAM ─────────────────────────────────────────────────────
function drawDiag(){
  var svg=E('dsvg');if(!svg||!P)return;
  // The SVG box itself now flexes to fill whatever vertical room is left in the center column
  // (see .dp/#dsvg CSS — it grows to match the right-hand Order column's height). Rather than a
  // fixed viewBox that gets letterboxed/wasted inside that variable-height box, match the
  // viewBox to the actual rendered pixel size each time, so every coordinate in this function
  // (all derived from VW/VH already) genuinely fills the available space with no distortion.
  var VW=Math.round(svg.clientWidth)||600,VH=Math.max(170,Math.round(svg.clientHeight)||230);
  if(svg.setAttribute)svg.setAttribute('viewBox','0 0 '+VW+' '+VH);
  var p=P,tp=S.type;
  // k scales every font-size/stroke-width/radius in this diagram with how tall it's actually
  // rendered — otherwise a bigger diagram box just meant more empty canvas around the same
  // small 7-9px text, instead of everything (text included) actually getting bigger.
  var k=Math.max(1,Math.min(2.4,VH/230));
  // Text gets its own, far flatter scale. Geometry can grow with the box;
  // labels should stay the size labels are, or the drawing becomes a poster.
  // Fig.01 sets the reference at 8-9px.
  var kt=Math.max(0.92,Math.min(1.18,VH/420));
  // Hardware scale. The balls and brackets are physically small parts; letting
  // them grow with k (which reaches 2.3) made them bigger than the plates they
  // bolt to and swamped the drawing.
  var kh=Math.max(0.9,Math.min(1.3,k));
  // Scale so lid AND box both fit: lid horizontal, box below
  // Vertical budget must cover BOTH the box depth below the hinge AND how high the lid's tip
  // swings above the hinge line at full open (up to the full lid length when oa→90°) — the old
  // formula only ever reserved a flat 20% of L for "above the hinge," so a deep lid on a
  // shallow box (small BH, large L, oa near 90) had its open-ghost line shoot off the top of
  // the canvas. Basing the budget on the true swing reach fixes that for every combination.
  // Always budget for the full 90° swing here, regardless of the current Max Open Angle
  // setting — using S.oa made the whole diagram rescale/zoom every time that slider moved,
  // which reads as the diagram "changing size" rather than just showing a shorter swing arc.
  // Reserving the full-swing budget keeps the scale (and everything's on-screen size) constant;
  // a smaller max angle then just draws a shorter open-ghost line within that same frame.
  // Reserve headroom to bracket A, not to the lid tip. This diagram shows the
  // CLOSED lid and its dimensions; budgeting for a full 90 degree swing it
  // never draws left a 200px empty band across the top of the canvas.
  var lidRise=p.a;
  var vSpan=Math.max(lidRise+p.BH, p.L*0.15);
  var sc=Math.min((VW*0.34)/p.L, (VH-46)/vSpan);
  // Center the drawing horizontally: the lid+box block runs from ox to ox+Ls, and the results
  // sidebar text runs further right from there — without accounting for that sidebar, a fixed ox
  // left the whole thing looking pinned to the left with a large dead gap on the right.
  // ox starts as just a small left margin — the real centering happens AFTER the whole
  // diagram (box/lid + dimension lines + results-sidebar text) is actually drawn and measured
  // via getBBox() below. Guessing the sidebar's rendered text width ahead of time (the old
  // approach) was never accurate — text width depends on the actual characters/font metrics,
  // not a flat estimate — and an overestimate there is exactly what left a big dead gap on the
  // right instead of true centering.
  var ox=30;
  // oy leaves headroom above the hinge for the fully-open lid, while still keeping the box
  // bottom on-canvas.
  var oy=Math.max(16, Math.min(lidRise*sc+14, VH-p.BH*sc-28));
  var Ls=p.L*sc,BHs=p.BH*sc,as=p.a*sc,Bxs=p.Bx*sc;
  var bos=BOFF_A*sc;        // A arm = 20mm in diagram pixels
  var Ds=(p.D||0.070)*sc;   // B depth = D in diagram pixels (NOT the same as bos!)
  // A ball: 20mm below lid surface → ay = oy + bos
  var ax=ox+as, ay=oy+bos;
  // B ball: D below hinge → by = oy + Ds  (THIS WAS THE BUG — was oy+bos before)
  var bx=ox+Bxs, by=oy+Ds;
  // Strut tube/rod split using compLen
  var strutD=Math.sqrt(Math.pow(bx-ax,2)+Math.pow(by-ay,2));
  var compPx=p.compLen?(p.compLen/1000)*sc:strutD*0.85;
  var tfD=strutD>0?Math.min(compPx/strutD,0.97):0.85;
  var mx2=ax+(bx-ax)*tfD,my2=ay+(by-ay)*tfD;
  // Everything in this diagram is drawn inside a scale(-1,1) group so the hinge
  // sits on the right, matching Fig.01 and the 3D. Text cannot ride that flip or
  // it comes out backwards, so each label is wrapped in its own counter-flip
  // about its anchor: the two scales cancel and the glyphs land upright at the
  // mirrored position. The anchor side flips too - a label that sat to the left
  // of its point is now annotating geometry whose clear space is on the right.
  var MXD=-1;
  var T=function(c,a,x,y,t,fs){
    a=a||'middle';
    if(MXD<0&&a!=='middle')a=(a==='end')?'start':'end';
    var el='<text font-family="ui-monospace,Menlo,Consolas,monospace" font-size="'+((fs||9)*kt).toFixed(1)+'" letter-spacing="0.06em" fill="'+c+'" text-anchor="'+a+'" x="'+x+'" y="'+y+'">'+t+'</text>';
    return MXD<0?('<g transform="translate('+(2*x).toFixed(1)+',0) scale(-1,1)">'+el+'</g>'):el;
  };
  // Same ruled drafting grid Fig.01 draws, on the same 22px pitch, so the two
  // figures read as the same drawing surface rather than two separate tools.
  var g='<rect width="'+VW+'" height="'+VH+'" fill="#fff"/>'
   +'<defs><pattern id="dgrid" width="22" height="22" patternUnits="userSpaceOnUse">'
   +'<path d="M22 0 L0 0 0 22" fill="none" stroke="#ececea" stroke-width="1"/></pattern></defs>'
   +'<rect width="'+VW+'" height="'+VH+'" fill="url(#dgrid)"/>'
   +'<g id="diagContent"><g transform="scale('+MXD+',1)">'
   +'<defs>'
   +'<marker id="mA" markerWidth="6" markerHeight="6" refX="3" refY="3" orient="auto"><path d="M0,0L6,3L0,6z" fill="#ff7a00"/></marker>'
   +'<marker id="mAL" markerWidth="6" markerHeight="6" refX="3" refY="3" orient="auto"><path d="M6,0L0,3L6,6z" fill="#ff7a00"/></marker>'
   +'<marker id="mB" markerWidth="6" markerHeight="6" refX="3" refY="3" orient="auto"><path d="M0,0L6,3L0,6z" fill="#17171a"/></marker>'
   +'<marker id="mBL" markerWidth="6" markerHeight="6" refX="3" refY="3" orient="auto"><path d="M6,0L0,3L6,6z" fill="#17171a"/></marker>'
   +'</defs>';
  if(tp==='box_lid'){
    // Box
    g+='<rect x="'+ox+'" y="'+oy+'" width="'+Ls+'" height="'+BHs+'" fill="#fafaf8" stroke="#ececea" stroke-width="1" stroke-dasharray="3,3"/>';
    g+='<line x1="'+ox+'" y1="'+oy+'" x2="'+ox+'" y2="'+(oy+BHs)+'" stroke="#55555a" stroke-width="'+(2.5*k)+'"/>';
    g+='<line x1="'+ox+'" y1="'+(oy+BHs)+'" x2="'+(ox+Ls)+'" y2="'+(oy+BHs)+'" stroke="#55555a" stroke-width="'+(1.5*k)+'"/>';
    g+='<line x1="'+(ox+Ls)+'" y1="'+oy+'" x2="'+(ox+Ls)+'" y2="'+(oy+BHs)+'" stroke="#c9c9c4" stroke-width="'+(2.5*k)+'"/>';
    // Lid
    g+='<line x1="'+ox+'" y1="'+oy+'" x2="'+(ox+Ls)+'" y2="'+oy+'" stroke="#17171a" stroke-width="'+(5*k)+'" stroke-linecap="round"/>';
    // Hinge — drawn as an actual barrel-and-leaf hinge, not the ball-stud style used for A/B (a
    // barrel hinge and a ball-stud fitting are different hardware; reusing the same round orange
    // icon for both made the hinge read as a third ball joint instead of a hinge). The WALL-side
    // leaf is drawn differently per mount type below the barrel — that's the only side that
    // actually differs (see calcP: hingeOff/mount type never changes anything about the lid
    // side), so varying just that leaf is simpler and more accurate than duplicating an
    // identical lid-side leaf across all three options. Everything sits at/below oy so it never
    // competes with the "A = ...mm" dimension line above, or (for shallow boxes) the B bracket
    // further down — both were genuine collisions in an earlier version.
    // Leaves that hang below the barrel (flush/inside) must stay clear of the B bracket, which
    // sits Ds px below oy — for a shallow box Ds can be small, so the leaf length is capped to
    // half that distance rather than a flat constant (a flat 16k reached into B for shallow
    // boxes in an earlier version — the exact collision the very first hinge-mount glyph had).
    var leafH=Math.max(6,Math.min(16*k,Ds*0.5));
    if(S.hingem==='overlay'){
      // Strap top/bottom must clear the HINGE label's own bounding box (baseline oy-11k, and
      // text ascends roughly 7k above that) — a first version put the strap right above the
      // ball and it visibly overlapped the "HINGE" text underneath it, caught live.
      g+='<rect x="'+(ox-15*k)+'" y="'+(oy-24*k)+'" width="'+(15*k)+'" height="'+(5*k)+'" rx="1" fill="#6e6e6b" stroke="#fff" stroke-width="0.6"/>'+
         '<circle cx="'+(ox-12*k)+'" cy="'+(oy-21.5*k)+'" r="1" fill="#fff"/><circle cx="'+(ox-4*k)+'" cy="'+(oy-21.5*k)+'" r="1" fill="#fff"/>'+
         '<line x1="'+ox+'" y1="'+(oy-6*k)+'" x2="'+ox+'" y2="'+(oy-19*k)+'" stroke="#6e6e6b" stroke-width="'+(2*k)+'"/>';
    } else if(S.hingem==='inside'){
      var wallX=ox-(p.hingeOff||0)*sc;
      g+='<rect x="'+(wallX-2*k)+'" y="'+(oy+2*k)+'" width="'+(4*k)+'" height="'+leafH+'" rx="1" fill="#6e6e6b" stroke="#fff" stroke-width="0.6"/>'+
         '<circle cx="'+wallX+'" cy="'+(oy+leafH*0.35+2*k)+'" r="1" fill="#fff"/><circle cx="'+wallX+'" cy="'+(oy+leafH*0.8+2*k)+'" r="1" fill="#fff"/>'+
         '<line x1="'+wallX+'" y1="'+(oy+leafH*0.5+2*k)+'" x2="'+ox+'" y2="'+(oy+leafH*0.5+2*k)+'" stroke="#55555a" stroke-width="'+(1.5*k)+'"/>'+
         T('#ff7a00','end',wallX-3*k,oy+leafH+2*k+10,'true wall face',6.5);
    } else {
      // Flush: leaf mortised right at the corner, meeting the barrel with no offset.
      g+='<rect x="'+(ox-2*k)+'" y="'+(oy+2*k)+'" width="'+(4*k)+'" height="'+leafH+'" rx="1" fill="#6e6e6b" stroke="#fff" stroke-width="0.6"/>'+
         '<circle cx="'+ox+'" cy="'+(oy+leafH*0.35+2*k)+'" r="1" fill="#fff"/><circle cx="'+ox+'" cy="'+(oy+leafH*0.8+2*k)+'" r="1" fill="#fff"/>';
    }
    g+='<circle cx="'+ox+'" cy="'+oy+'" r="'+(6*kh)+'" fill="#fff" stroke="#17171a" stroke-width="'+(2.2*kh)+'"/>'+T('#ff7a00','middle',ox,oy-11*k,'HINGE',8);
    // Strut
    g+='<line x1="'+ax+'" y1="'+ay+'" x2="'+mx2+'" y2="'+my2+'" stroke="#ff7a00" stroke-width="'+(7*k)+'" stroke-linecap="round"/>';
    g+='<line x1="'+mx2+'" y1="'+my2+'" x2="'+bx+'" y2="'+by+'" stroke="#6a6a68" stroke-width="'+(3.5*k)+'" stroke-linecap="round"/>';
    // A BRACKET: plate on lid underside, arm drops bos below to ball
    var aPlY=oy; // plate at lid surface
    g+='<line x1="'+ax+'" y1="'+aPlY+'" x2="'+ax+'" y2="'+ay+'" stroke="#ff7a00" stroke-width="'+(3*k)+'" stroke-linecap="round"/>';
    g+='<rect x="'+(ax-12*k)+'" y="'+(aPlY-4*k)+'" width="'+(24*k)+'" height="'+(8*k)+'" rx="2" fill="#ff7a00" stroke="white" stroke-width="0.8"/>';
    g+='<circle cx="'+(ax-7*k)+'" cy="'+aPlY+'" r="'+(1.8*k)+'" fill="white"/>';
    g+='<circle cx="'+(ax+7*k)+'" cy="'+aPlY+'" r="'+(1.8*k)+'" fill="white"/>';
    // Label sits beside the arm's vertical midpoint (between the lid-surface plate and the
    // ball) rather than above the lid line — the old y (aPlY-bos/2+5k) could land almost
    // exactly on the lid stroke itself for a short on-screen arm, which is exactly the kind of
    // overlap that read as "cluttered."
    g+=T('#ff7a00','start',ax+7*k,(aPlY+ay)/2+3*k,'20mm',7.5);
    g+='<circle cx="'+ax+'" cy="'+ay+'" r="'+(6.5*kh)+'" fill="#fff" stroke="#17171a" stroke-width="'+(2.2*kh)+'"/>'+T('#ff7a00','middle',ax,ay-10*k,'A',9);
    // B BRACKET: mounted directly where B actually sits, ON the side wall we're looking at
    // (the box interior in this view) — NOT a long arm reaching over from the front wall.
    // The stand-off distance (p.stoff — NOT a fixed 20mm; it's 15mm for an 8mm-shaft strut,
    // 20mm for 10mm-shaft) is the gap between the wall face and the ball, purely so the strut's
    // own tube doesn't rub against the wall as it swings — separate from Tube OD (the strut
    // body's own diameter, shown in the legend below).
    // One small bracket unit — same arm+plate+ball structure as A, just rotated 90°: A's plate
    // sits flat on the (horizontal) lid so it's drawn as a horizontal rect; B's plate sits flat
    // on the (vertical) wall so it's drawn as a vertical rect. The previous version drew a
    // separate thick gusset bar UNDER a second plate, which read as two stacked brackets rather
    // than one — this replaces both with a single plate the same visual weight as A's.
    // Plate sits AWAY from the wall (toward the box interior), short stub arm back to the ball
    // near the wall corner — matching the 2D Geometry canvas's B bracket, which offsets its
    // plate the same direction (Bc.x+bArmPxB, away from the wall). The previous version offset
    // the plate the other way (bx-10k, toward the wall), which for a small Bx landed the plate
    // almost exactly on top of the box's own front-wall stroke — reported as "the B bracket
    // sits on the back wall."
    var bPlX=bx+10*k;
    g+='<line x1="'+bPlX+'" y1="'+by+'" x2="'+bx+'" y2="'+by+'" stroke="#17171a" stroke-width="'+(3*k)+'" stroke-linecap="round"/>';
    g+='<rect x="'+(bPlX-4*k)+'" y="'+(by-12*k)+'" width="'+(8*k)+'" height="'+(24*k)+'" rx="2" fill="#17171a" stroke="white" stroke-width="0.8"/>';
    g+='<circle cx="'+bPlX+'" cy="'+(by-7*k)+'" r="'+(1.8*k)+'" fill="white"/>';
    g+='<circle cx="'+bPlX+'" cy="'+(by+7*k)+'" r="'+(1.8*k)+'" fill="white"/>';
    // B ball stud
    g+='<circle cx="'+bx+'" cy="'+by+'" r="'+(6.5*kh)+'" fill="#fff" stroke="#17171a" stroke-width="'+(2.2*kh)+'"/>'+T('#17171a','middle',bx,by+16*k,'B',9);
    // Standoff and D labels are stacked vertically below B, centred on bx, instead of sitting
    // beside the plate — a beside placement needs ~90px of clear horizontal run for the text,
    // and for a long/thin lid B can land close enough to A that nothing fits there (caught
    // live: at L=2000mm/T=3mm the label ran straight into A's plate no matter how far left it
    // was pushed). Stacking below only needs vertical room, which D already proved is safe here.
    g+=T('#17171a','middle',bx,by+27*k,p.stoff+'mm standoff',7.5);
    // D — vertical drop from hinge to B — is shown right here, just below the bracket, instead
    // of a dimension line stranded off in the left margin far from the thing it's measuring.
    g+=T('#17171a','middle',bx,by+41*k,'D = '+Math.round((p.D||0.070)*1000)+'mm below hinge',7.5);
    // DIMENSION: A along lid (above the lid) — pushed further up when a hinge-mount glyph is
    // occupying the space directly above the ball — only overlay's strap sits up there now
    // (flush/inside's leaves hang below the barrel instead), so only overlay needs the reserve.
    var glyphReserve=S.hingem==='overlay'?21*k:0;
    var d1y=oy-20*k-glyphReserve;
    g+='<line x1="'+ox+'" y1="'+d1y+'" x2="'+ax+'" y2="'+d1y+'" stroke="#ff7a00" stroke-width="'+(1.2*k)+'" marker-start="url(#mAL)" marker-end="url(#mA)"/>';
    g+='<line x1="'+ox+'" y1="'+(d1y-4*k)+'" x2="'+ox+'" y2="'+(d1y+4*k)+'" stroke="#ff7a00" stroke-width="1"/>';
    g+='<line x1="'+ax+'" y1="'+(d1y-4*k)+'" x2="'+ax+'" y2="'+(d1y+4*k)+'" stroke="#ff7a00" stroke-width="1"/>';
    g+=T('#ff7a00','middle',(ox+ax)/2,d1y-5*k,'A = '+Math.round(p.a*1000)+' mm',8.5);
    // DIMENSION: B forward from back wall — drawn right next to B itself (near the hinge),
    // not stranded down at the box floor where B doesn't actually reach.
    var d2y=Math.max(d1y-16*k,8);
    g+='<line x1="'+ox+'" y1="'+d2y+'" x2="'+bx+'" y2="'+d2y+'" stroke="#17171a" stroke-width="'+(1.2*k)+'" marker-start="url(#mBL)" marker-end="url(#mB)"/>';
    g+='<line x1="'+ox+'" y1="'+(d2y-4*k)+'" x2="'+ox+'" y2="'+(d2y+4*k)+'" stroke="#17171a" stroke-width="1"/>';
    g+='<line x1="'+bx+'" y1="'+(d2y-4*k)+'" x2="'+bx+'" y2="'+(d2y+4*k)+'" stroke="#17171a" stroke-width="1"/>';
    g+=T('#17171a','middle',(ox+bx)/2,d2y-5*k,'B = '+Math.round((p.Bx+(p.hingeOff||0))*1000)+' mm fwd from back wall (hinge)',8.5);
    // Box height
    var d4x=ox+Ls+18*k;
    g+='<line x1="'+d4x+'" y1="'+oy+'" x2="'+d4x+'" y2="'+(oy+BHs)+'" stroke="#888" stroke-width="0.8"/>';
    g+='<line x1="'+(d4x-3*k)+'" y1="'+oy+'" x2="'+(d4x+3*k)+'" y2="'+oy+'" stroke="#888" stroke-width="0.8"/>';
    g+='<line x1="'+(d4x-3*k)+'" y1="'+(oy+BHs)+'" x2="'+(d4x+3*k)+'" y2="'+(oy+BHs)+'" stroke="#888" stroke-width="0.8"/>';
    g+=T('#8a8a86','start',d4x+4*k,oy+BHs/2+3*k,S.bh+'mm',8);
    // Results sidebar — kept clear of the box-height "Xmm" label just to its left (that label
    // starts at d4x=ox+Ls+18k and its own text can run ~30px wide), so this needs a bigger gap
    // than the label's start offset alone would suggest.
    var rx=ox+Ls+62*k;
  } else {
    // Top-hung window or bottom-hung hatch: hinge at one end, panel hangs/stands along the
    // hinge axis when closed, frame bracket (B) is set back behind the hinge line.
    var isTop=tp==='top_hinge';
    var scT=Math.min((VW*0.30)/p.L,(VH-46)/p.L);
    // hy0's margin must scale with k too — several elements below (the frame jamb, in
    // particular) are drawn at a k-scaled length centered on hy0; if hy0's own margin stayed
    // fixed while that length grew with k, the jamb would poke off the top/bottom of a tall
    // canvas.
    var hy0=isTop?26*k:(VH-26*k);
    var aT=p.a*scT,BxT=p.Bx*scT,ByT=p.By*scT;
    // hx0 starts as just enough left margin to fit the frame jamb + its dimension line — true
    // horizontal centering of the whole drawing (jamb, panel, results sidebar) happens AFTER
    // it's actually drawn, via getBBox() measurement below (see box_lid branch for why: guessing
    // rendered text width ahead of time is never accurate).
    var hx0=Math.abs(BxT)+30*k+20;
    // SVG y grows downward; physics y grows upward, so svg_y = hy0 - physics_y*scale.
    // A0 (closed position) is at physics (0,-a) for top_hinge, (0,+a) for bottom_hinge.
    var axT=hx0,ayT=isTop?hy0+aT:hy0-aT;
    var bxT=hx0+BxT, byT=hy0-ByT;
    var strutDT=Math.sqrt(Math.pow(bxT-axT,2)+Math.pow(byT-ayT,2));
    var compPxT=p.compLen?(p.compLen/1000)*scT:strutDT*0.85;
    var tfT=strutDT>0?Math.min(compPxT/strutDT,0.97):0.85;
    var mx2T=axT+(bxT-axT)*tfT,my2T=ayT+(byT-ayT)*tfT;
    // Frame jamb at the bracket's true standoff position — a short fixed-length segment
    // straddling hinge height, same on both sub-types (was previously scaled by aT and
    // could run off the top/bottom of the 170px-tall canvas).
    var frXT=hx0+BxT;
    g+='<line x1="'+frXT+'" y1="'+(hy0-22*k)+'" x2="'+frXT+'" y2="'+(hy0+22*k)+'" stroke="#7a8296" stroke-width="'+(7*k)+'" stroke-linecap="round"/>';
    g+='<line x1="'+(frXT-16*k)+'" y1="'+hy0+'" x2="'+(frXT+16*k)+'" y2="'+hy0+'" stroke="#55555a" stroke-width="'+(2.5*k)+'"/>';
    // Closed panel (solid) + fully-open ghost (dashed)
    g+='<line x1="'+hx0+'" y1="'+hy0+'" x2="'+hx0+'" y2="'+ayT+'" stroke="#17171a" stroke-width="'+(5*k)+'" stroke-linecap="round"/>';
    var θoT=S.oa*Math.PI/180;
    var pOAx=hx0+p.a*Math.sin(θoT)*scT;
    var pOAy=isTop?hy0-(-p.a*Math.cos(θoT))*scT:hy0-(p.a*Math.cos(θoT))*scT;
    g+='<line x1="'+hx0+'" y1="'+hy0+'" x2="'+pOAx+'" y2="'+pOAy+'" stroke="#ff7a00" stroke-width="'+(1.5*k)+'" stroke-dasharray="5,3" opacity="0.4"/>';
    // Hinge
    g+='<circle cx="'+hx0+'" cy="'+hy0+'" r="'+(7*k)+'" fill="#e88a00"/>'+T('#ff7a00','middle',hx0,hy0+(isTop?-11:16)*k,'HINGE',8);
    // Strut: tube + rod
    g+='<line x1="'+axT+'" y1="'+ayT+'" x2="'+mx2T+'" y2="'+my2T+'" stroke="#ff7a00" stroke-width="'+(7*k)+'" stroke-linecap="round"/>';
    g+='<line x1="'+mx2T+'" y1="'+my2T+'" x2="'+bxT+'" y2="'+byT+'" stroke="#6a6a68" stroke-width="'+(3.5*k)+'" stroke-linecap="round"/>';
    // A: small collar directly on the panel (no separate offset arm — matches the physics)
    g+='<circle cx="'+axT+'" cy="'+ayT+'" r="'+(6*k)+'" fill="#ff7a00" stroke="#fff" stroke-width="1.5"/>'+T('#ff7a00','middle',axT,ayT+(isTop?-10:16)*k,'A',9);
    // B: plate mounted directly on the frame jamb — the jamb itself is drawn vertical, so the
    // plate lying flat against it should be too (was a horizontal rect, i.e. drawn side-on to
    // the surface it's actually mounted flat against).
    g+='<rect x="'+(bxT-4*k)+'" y="'+(byT-10*k)+'" width="'+(8*k)+'" height="'+(20*k)+'" rx="2" fill="#17171a" stroke="white" stroke-width="0.8"/>';
    g+='<circle cx="'+bxT+'" cy="'+byT+'" r="'+(6*kh)+'" fill="#fff" stroke="#17171a" stroke-width="'+(2.2*kh)+'"/>'+T('#17171a','middle',bxT,byT+(isTop?16:-10)*k,'B',9);
    // Dimension: A from hinge
    var d1x=hx0-26*k;
    g+='<line x1="'+d1x+'" y1="'+hy0+'" x2="'+d1x+'" y2="'+ayT+'" stroke="#ff7a00" stroke-width="1" marker-start="url(#mAL)" marker-end="url(#mA)"/>';
    // The label normally sits just left of the dimension line (d1x-18k), but for a large
    // standoff on a small/thick panel that x can drift as far right as bxT itself (hx0 shrinks
    // the standoff back out of its own margin) — clamp it to stay clear of the B ball, caught
    // by a live sweep across small/large panel sizes.
    g+=T('#ff7a00','middle',Math.min(d1x-18*k,bxT-24*k),(hy0+ayT)/2+3,'A='+Math.round(p.a*1000)+'mm',7.5);
    // Dimension: B setback from hinge line — anchored near B's actual height (byT) and
    // clamped inside the 0..VH canvas. The previous fixed hy0±30 offset ran off the top of
    // the canvas for top_hinge and off the bottom for bottom_hinge.
    var d2y=Math.max(10,Math.min(VH-10,byT+(isTop?-14:14)*k));
    g+='<line x1="'+hx0+'" y1="'+d2y+'" x2="'+bxT+'" y2="'+d2y+'" stroke="#17171a" stroke-width="1" marker-start="url(#mBL)" marker-end="url(#mB)"/>';
    g+=T('#17171a','middle',(hx0+bxT)/2,d2y+(isTop?-5:12)*k,'set back '+Math.round(Math.abs(p.Bx)*1000)+'mm',7.5);
    // Results sidebar — row y-offsets scale with k (font-size already does via T()); these were
    // previously fixed raw pixels (40/51/62/73/84) which matched the box_lid sidebar's spacing
    // only at k=1 — at larger diagram sizes (k>1) the ~15-17px-tall text was packed into an
    // unscaled 11px line pitch, so adjacent lines visually collided. Scaling the whole
    // 40+i*11 sequence by k keeps the line pitch proportional to the font size at any size,
    // matching the box_lid sidebar (oy+10k, oy+21k, oy+32k, ...) which already got this right.
    var rxT=Math.max(bxT,hx0)+70*k;
    if(p.soAng!=null)g+=T('#8a8a86','start',rxT,73*k,'Holds open from '+p.soAng+'°',9);
    g+=T('#8a8a86','start',rxT,84*k,'Frame bracket '+Math.round(Math.abs(p.By)*1000)+'mm '+(isTop?'below':'above')+' hinge',9);
  }
  g+='</g></g>';
  svg.innerHTML=g;
  // The spec that used to float inside the drawing. Out here it is a row
  // under the figure, which is where Fig.01 puts its legend.
  var ds=E('dspec');
  if(ds){
    var bits=[(p.recLen||'?')+'mm extended',(p.compLen||'?')+'mm compressed',
      '12mm clearance at full close'];
    if(p.soAng!=null)bits.push('kicks in at '+p.soAng+'\u00b0');
    bits.push('latch '+(p.latchF<=0?'zero':p.latchF+'N'));
    ds.textContent=bits.join(' \u00b7 ');
  }
  // True horizontal centering: rather than guess the rendered width of the box/lid + dimension
  // lines + results-sidebar text ahead of time (never accurate — text width depends on actual
  // characters and font metrics), measure what was ACTUALLY drawn via getBBox() now that it's
  // in the DOM, then shift the whole group so it's genuinely centered in the canvas. This
  // replaces an earlier flat-pixel-estimate approach that consistently under-centered content
  // (left-biased it, leaving a dead gap on the right) whenever the real text was narrower than
  // the guess.
  var content=svg.getElementById?svg.getElementById('diagContent'):null;
  if(content&&content.getBBox){
    try{
      var bb=content.getBBox();
      var dx=(VW-bb.width)/2-bb.x;
      if(dx<4) dx=4; // never push content off the left edge
      // Centre vertically as well as horizontally. The layout has to reserve
      // headroom before it knows how far the lid ghost and the dimension stack
      // actually reach, so any fixed reserve is either wasteful or too tight -
      // it was leaving a 160px empty band across the top. Measuring what was
      // really drawn removes the guess entirely.
      var dy=(VH-bb.height)/2-bb.y;
      if(dy+bb.y<4) dy=4-bb.y;   // never clip the top off
      content.setAttribute('transform','translate('+dx.toFixed(1)+','+dy.toFixed(1)+')');
    }catch(e){/* getBBox can throw if the svg isn't laid out yet — leave uncentered rather than break */}
  }
}
// Export the current installation diagram as a PNG the user can save/print/send to a customer
// or installer — rasterized at 2x the on-screen size so it stays sharp when zoomed or printed.
function saveDiagram(){
  var svg=E('dsvg');if(!svg)return;
  var w=svg.clientWidth||900,h=svg.clientHeight||230;
  var xml=new XMLSerializer().serializeToString(svg);
  var svgBlob=new Blob([xml],{type:'image/svg+xml;charset=utf-8'});
  var url=URL.createObjectURL(svgBlob);
  var img=new Image();
  img.onload=function(){
    var scale=2;
    var cv=document.createElement('canvas');
    cv.width=w*scale;cv.height=h*scale;
    var ctx=cv.getContext('2d');
    ctx.fillStyle='#fff';ctx.fillRect(0,0,cv.width,cv.height);
    ctx.drawImage(img,0,0,cv.width,cv.height);
    URL.revokeObjectURL(url);
    cv.toBlob(function(blob){
      if(!blob)return;
      var stamp=new Date().toISOString().slice(0,10);
      var fname='gas-strut-install-'+S.type+(P&&P.recLen?'-'+P.recLen+'mm':'')+'-'+stamp+'.png';
      var a=document.createElement('a');
      a.href=URL.createObjectURL(blob);a.download=fname;
      document.body.appendChild(a);a.click();document.body.removeChild(a);
    },'image/png');
  };
  img.onerror=function(){URL.revokeObjectURL(url);};
  img.src=url;
}
// ─── 2D CANVAS ────────────────────────────────────────────────────────────────
// Builds the bench sheet from whatever is on screen right now and prints it.
// Everything on the page is hidden by the print stylesheet except #sx-printsheet,
// so what comes out is one page: the part, the panel it was solved for, the three
// bracket positions and the installation diagram.
function printFittingSheet(){
  var host=document.getElementById('sx-printsheet');if(!host||!P)return;
  var p=P,txt=function(id){var e=E(id);return e?(e.textContent||'').trim():'-';};
  var fit=E('sxfit'),fitting=fit?fit.value:'-';
  var noFit=p.noFit;
  var rows=[
    ['Strut', noFit?'No standard strut fits':('8mm Gas Strut  '+(p.recLen||'-')+'mm')],
    ['SKU', noFit?'-':('STRUT-8-'+p.recLen)],
    ['Pressure', noFit?'-':((p.recF||'-')+' N')],
    ['Quantity', pQty+' \u00d7'],
    ['End fittings', fitting],
    ['Install length', txt('kv-len')],
    ['Stroke', txt('kv-str')],
    ['Kicks in at', txt('kv-kick')]
  ];
  var panel=[
    ['Panel type', S.type==='box_lid'?'Box lid':'Window'],
    ['Panel size', S.l+' \u00d7 '+S.wd+' mm'],
    ['Panel weight', S.w+' kg'],
    ['Box wall height', S.bh+' mm'],
    ['Opening angle', S.oa+'\u00b0'],
    ['Struts per panel', S.ns===1?'One':'Two']
  ];
  var brackets=[
    ['A','Hinge to bracket A, along the panel',txt('r-a')],
    ['B','Bracket B in from the hinge wall',txt('r-bf')],
    ['C','Bracket B offset off the hinge line',txt('r-bD')]
  ];
  function tbl(title,pairs){
    return '<table><tr><th colspan="2">'+title+'</th></tr>'+pairs.map(function(r){
      return '<tr><td>'+r[0]+'</td><td class="v">'+r[1]+'</td></tr>';}).join('')+'</table>';
  }
  var bTbl='<table><tr><th colspan="3">Bracket positions</th></tr>'+brackets.map(function(r){
    return '<tr><td class="k">'+r[0]+'</td><td>'+r[1]+'</td><td class="v">'+r[2]+'</td></tr>';
  }).join('')+'</table>';
  var svg=E('dsvg'),svgHtml=svg?('<svg xmlns="http://www.w3.org/2000/svg" viewBox="'+
    (svg.getAttribute('viewBox')||'0 0 600 230')+'">'+svg.innerHTML+'</svg>'):'';
  host.innerHTML='<h2>Gas strut fitting sheet</h2>'+
    '<div class="ps-sub">Struxa \u00b7 struxamotion.com</div>'+
    svgHtml+bTbl+tbl('Recommended strut',rows)+tbl('Panel',panel)+
    '<div class="ps-foot">Measure twice before drilling. Positions are from the hinge pivot. '+
    'Generated '+new Date().toLocaleDateString()+'.</div>';
  window.print();
}
function draw2D(){
  var cv=E('c2d');if(!cv)return;
  // Size the bitmap in DEVICE pixels and scale the context, then draw in CSS
  // pixels. Without this the canvas renders at 1x on a 1.25x or 2x display and
  // every line comes out soft - that, not the styling, is the real reason the
  // design's figures looked sharper than ours.
  // Floor the ratio at 1. Zooming the browser OUT drops devicePixelRatio below
  // 1 (0.8 at 80% zoom), which made the bitmap SMALLER than its own CSS box and
  // left CSS to upscale it - blurry for exactly the people who zoomed out to
  // get more of the drawing on screen.
  // Measure the CANVAS's own layout box, not the parent's. The canvas is a flex
  // child now, so the parent is taller than the canvas by the height of the
  // figure header - sizing from the parent stretched the drawing vertically.
  // Do not write inline width/height either; CSS owns the display size, this
  // only sets the bitmap resolution.
  var dpr=Math.max(window.devicePixelRatio||1,1),r=cv.getBoundingClientRect();
  var cw=Math.round(r.width)||400,ch=Math.round(r.height)||300;
  cv.width=Math.round(cw*dpr);cv.height=Math.round(ch*dpr);
  if(!cw||!ch||!P)return;
  var ctx=cv.getContext('2d'),p=P,deg=S.ang,tp=S.type,oa=S.oa,θ=deg*Math.PI/180;
  ctx.setTransform(dpr,0,0,dpr,0,0);

  // ── Drafting palette, read off the design's Fig.01 ─────────────────────────
  // The old figure spoke a different visual language entirely: a royal-blue
  // panel, a six-pixel mud-coloured sweep band, and solid orange discs for the
  // ball joints. The design draws a technical elevation - ink outlines, ONE
  // accent colour on the part being sold, and white-centred rings for anything
  // that pivots. Everything below follows that, and nothing it used to tell the
  // installer has been dropped.
  // The design draws the hinge on the RIGHT with the panel swinging up and
  // to the left. Rather than hand-flip thirty coordinates, every x offset
  // measured FROM the hinge goes through MX. c2() applies it to the geometry;
  // anything written as a raw pixel nudge from a point multiplies by it too,
  // and label alignment flips with it. Set MX=1 to get the old view back.
  var MX=-1;
  var INK='#17171a',MUTE='#8a8a86',FAINT='#c9c9c4',GRID='#ececea',
      ACC='#ff7a00',ROD='#6a6a68',BOXF='#fafaf8',MONO='px ui-monospace,Menlo,Consolas,monospace';
  function lbl(t,x,y,col,sz,al,bold){
    ctx.save();
    ctx.font=(bold?'bold ':'')+(sz||9)+MONO;
    ctx.textAlign=al||'left';
    // knock the drawing back out from under the text so labels stay readable
    // wherever they land - on the lid line, the box edge or the grid
    ctx.lineWidth=3;ctx.lineJoin='round';ctx.strokeStyle='rgba(255,255,255,.92)';
    ctx.strokeText(t,x,y);
    ctx.fillStyle=col||MUTE;ctx.fillText(t,x,y);
    ctx.restore();}
  // Anything that rotates is drawn the same way: white disc, heavy ink ring.
  // A solid disc reads as a rivet; the ring reads as a pivot, which is what
  // these actually are.
  function pivot(x,y,rad){
    ctx.beginPath();ctx.arc(x,y,rad,0,Math.PI*2);
    ctx.fillStyle='#fff';ctx.fill();ctx.lineWidth=2.4;ctx.strokeStyle=INK;ctx.stroke();}

  ctx.fillStyle='#fff';ctx.fillRect(0,0,cw,ch);
  // A ruled grid on a 22px pitch, as the design draws it, rather than a field
  // of dots - it reads as drafting paper and gives the drawing a sense of scale.
  ctx.strokeStyle=GRID;ctx.lineWidth=1;
  for(var gx=22;gx<cw;gx+=22){ctx.beginPath();ctx.moveTo(gx+0.5,0);ctx.lineTo(gx+0.5,ch);ctx.stroke();}
  for(var gy=22;gy<ch;gy+=22){ctx.beginPath();ctx.moveTo(0,gy+0.5);ctx.lineTo(cw,gy+0.5);ctx.stroke();}

  var sc,hx,hy;
  if(tp==='box_lid'){
    // Scale so FULL open lid (height=L) fits above AND box (height=BH) fits below
    // The lid only ever reaches its MAX opening angle, never vertical, so
    // reserving a full lid-length of headroom above the hinge threw away space
    // on every panel that cannot open past about 70 degrees. Reserve the height
    // it actually rises to. The floor keeps a shallow-opening lid from scaling
    // up so far that the box runs off the sides.
    // Frame on the part of the drawing that says something: the box, and the
    // lid as far as bracket A. The hinge, both brackets, the strut and the box
    // all sit inside that. Past A the lid is a bare line heading off at an
    // angle, so letting it run out of frame costs no information and buys
    // about a third more scale on the box, which is the thing worth looking at.
    // rise still comes from the MAX opening angle, not the current one, so the
    // scale holds still while the lid animates instead of breathing in and out.
    var rise=Math.max(Math.sin(oa*Math.PI/180),0.40);
    sc=Math.min(cw*0.88/p.L, (ch-44)/(p.a*rise+p.BH));
    // Center the box+lid block horizontally — it always spans exactly [hx, hx+L*sc] (the lid
    // line only ever swings BETWEEN closed/flat, at x=hx+L*sc, and fully open/vertical, at
    // x=hx — so the box width IS the true horizontal extent, no separate measurement needed).
    hx=(cw+p.L*sc)/2;
    hy=p.a*rise*sc+24;
  } else {
    sc=Math.min(cw*0.70,ch*0.80)/p.L;hy=tp==='top_hinge'?ch*0.12:ch*0.82;
    // Center on the true swing envelope: the frame jamb sits leftExt behind the hinge, the arc
    // reaches rightExt in front of it. Centering on the CURRENT angle instead would make the
    // whole diagram slide sideways as it animates, since the panel line's x changes every frame.
    var leftExt=Math.abs(p.Bx)*sc+18,rightExt=(p.a*sc*0.68)*Math.sin(oa*Math.PI/180)+16;
    hx=(cw+(rightExt-leftExt))/2;
    hx=Math.max(40,Math.min(cw-40,hx));
  }
  // Publish the drawing scale so the Fig. 01 header can state a real ratio
  // instead of the design mock's hardcoded 1:10. sc is CSS px per metre, and a
  // CSS px is 1/96 inch = 0.26458 mm, so the on-screen ratio is
  // 1000mm / (sc * 0.26458). It is approximate - it moves with browser zoom and
  // display density - so the header labels it with a tilde.
  p.px_per_m=sc;
  var f1=E('fig1-meta');
  if(f1&&sc>0){var ratio=1000/(sc*0.26458);f1.textContent='~1:'+(ratio>=10?Math.round(ratio):ratio.toFixed(1));}
  function c2(px,py){return{x:hx+MX*px*sc,y:hy-py*sc};}
  // Where the panel's far end sits at any angle. Pulling this out of the three
  // branches it used to be inlined in is what makes the closed-position ghost
  // below free: it is just this same function at zero.
  function panelEnd(a){
    if(tp==='box_lid')return c2(p.L*Math.cos(a),p.L*Math.sin(a));
    if(tp==='top_hinge')return c2(p.L*Math.sin(a),-p.L*Math.cos(a));
    return c2(p.L*Math.sin(a),p.L*Math.cos(a));
  }
  var Bc=c2(p.Bx,p.By),pEnd=panelEnd(θ),cEnd=panelEnd(0);

  // ── Body: the box, or the frame the panel hangs in ────────────────────────
  if(tp==='box_lid'){
    var Ls2=p.L*sc,BHs2=p.BH*sc;
    var bx0=MX<0?hx-Ls2:hx;
    ctx.fillStyle=BOXF;ctx.fillRect(bx0,hy,Ls2,BHs2);
    ctx.strokeStyle=INK;ctx.lineWidth=2;ctx.strokeRect(bx0+0.5,hy+0.5,Ls2,BHs2);
    lbl('BOX',bx0+10,hy+BHs2-10,MUTE,9);
    // An inside-mounted hinge puts the pivot in from the wall, so the face the
    // installer measures from is NOT the pivot. That offset is the one thing
    // the three mount options actually change in the geometry, so it is the one
    // thing worth drawing - the little hardware leaves the old figure drew for
    // each option looked different without telling anyone anything.
    if(S.hingem==='inside'&&p.hingeOff){
      var wallX=hx-MX*p.hingeOff*sc;
      ctx.strokeStyle=FAINT;ctx.lineWidth=1.5;ctx.setLineDash([3,3]);
      ctx.beginPath();ctx.moveTo(wallX,hy-8);ctx.lineTo(wallX,hy+BHs2);ctx.stroke();ctx.setLineDash([]);
      lbl('TRUE WALL FACE',wallX-MX*6,hy+BHs2-26,FAINT,8,MX<0?'left':'right');
    }
  } else {
    // Frame jamb drawn at B's actual standoff (p.Bx, behind the hinge) — not a generic
    // crossbar — so the strut's frame-side ball reads as "mounted on the frame".
    var Ls2=p.L*sc,frX=hx+MX*p.Bx*sc,down=tp==='top_hinge'?1:-1;
    ctx.strokeStyle=INK;ctx.lineWidth=2;ctx.lineCap='butt';
    ctx.beginPath();ctx.moveTo(frX,hy-16*down);ctx.lineTo(frX,hy+Ls2*0.62*down);ctx.stroke();
    ctx.beginPath();ctx.moveTo(frX-18,hy);ctx.lineTo(frX+18,hy);ctx.stroke();
    lbl('FRAME',frX-MX*22,hy+Ls2*0.62*down+(down>0?14:-8),MUTE,9,MX<0?'left':'right');
  }

  // ── Closed position, as a dashed ghost ────────────────────────────────────
  // The design shows where the panel started, so the opening angle is something
  // you can SEE rather than just read off a number.
  // Only worth drawing once the panel has actually left it. At closed the ghost
  // lies exactly under the lid line and its label collides with the LID label.
  if(deg>2){
  ctx.strokeStyle=FAINT;ctx.lineWidth=1.5;ctx.setLineDash([6,4]);
  ctx.beginPath();ctx.moveTo(hx,hy);ctx.lineTo(cEnd.x,cEnd.y);ctx.stroke();
  ctx.setLineDash([]);
  var cSide=tp==='box_lid'?-MX:MX;
  lbl('CLOSED',cEnd.x+cSide*8,cEnd.y+(tp==='top_hinge'?14:-8),FAINT,8,cSide<0?'right':'left');
  }

  // ── Sweep arc + the angle it represents ───────────────────────────────────
  // The sweep used to be a 6px band in two muddy colours, which dominated the
  // drawing and read as a solid object. It is reference geometry, so it is a
  // hairline now; the kick-in point that band was there to show is called out
  // explicitly below instead of being encoded as a colour change.
  var ar=Math.max(26,Math.min(p.L*sc*0.30,62));
  var a0=Math.atan2(cEnd.y-hy,cEnd.x-hx),a1=Math.atan2(pEnd.y-hy,pEnd.x-hx);
  if(deg>0){
    ctx.strokeStyle=FAINT;ctx.lineWidth=1.5;
    ctx.beginPath();ctx.arc(hx,hy,ar,a0,a1,a1<a0);ctx.stroke();
    var am=(a0+a1)/2;
    lbl(deg+'°',hx+Math.cos(am)*(ar+18),hy+Math.sin(am)*(ar+18)+4,INK,12,'center',true);
  }
  // Kick-in: the angle the strut actually starts lifting at. Drawn as a short
  // accent tick ON the arc, which is the one thing in here the installer can
  // act on, so it gets the accent colour and nothing else does except the strut.
  if(P.soAng!==null&&P.soAng>0&&P.soAng<=oa){
    var ks=P.soAng*Math.PI/180,kE=panelEnd(ks);
    var ka=Math.atan2(kE.y-hy,kE.x-hx);
    ctx.strokeStyle=ACC;ctx.lineWidth=2.2;
    ctx.beginPath();
    ctx.moveTo(hx+Math.cos(ka)*(ar-7),hy+Math.sin(ka)*(ar-7));
    ctx.lineTo(hx+Math.cos(ka)*(ar+7),hy+Math.sin(ka)*(ar+7));ctx.stroke();
    lbl('KICKS IN '+P.soAng+'°',hx+Math.cos(ka)*(ar+12),hy+Math.sin(ka)*(ar+12)+3,ACC,8);
  }

  // ── The panel itself ──────────────────────────────────────────────────────
  // Was royal blue at 10px (and green for hatches), which is why the figure
  // never looked like the design no matter what else was fixed. Ink, 3px.
  ctx.strokeStyle=INK;ctx.lineWidth=3;ctx.lineCap='round';
  ctx.beginPath();ctx.moveTo(hx,hy);ctx.lineTo(pEnd.x,pEnd.y);ctx.stroke();
  // The lid tip now leaves the frame on purpose (see the scale above), so pin
  // its label to the edge rather than letting it disappear off the top with
  // the tip it belongs to.
  var lblX=pEnd.x-MX*8,lblY=pEnd.y+(tp==='top_hinge'?14:-6);
  lblX=Math.max(18,Math.min(cw-18,lblX));lblY=Math.max(14,Math.min(ch-26,lblY));
  lbl(tp==='box_lid'?'LID':'PANEL',lblX,lblY,MUTE,9,MX<0?'left':'right');

  // ── The strut: fat accent tube at the panel end, thin rod into the body ───
  // Which end is which is the single most useful thing this drawing says, so
  // the tube carries the accent and the rod stays grey.
  var Ac;
  if(tp==='box_lid'){
    Ac=c2(p.a*Math.cos(θ)+BOFF_A*Math.sin(θ),p.a*Math.sin(θ)-BOFF_A*Math.cos(θ));
  } else if(tp==='top_hinge'){Ac=c2(p.a*Math.sin(θ),-p.a*Math.cos(θ));}
  else{Ac=c2(p.a*Math.sin(θ),p.a*Math.cos(θ));}
  var compPx=p.compLen?(p.compLen/1000)*sc:0;
  var strutPx=Math.sqrt(Math.pow(Bc.x-Ac.x,2)+Math.pow(Bc.y-Ac.y,2));
  var tFrac=strutPx>0&&compPx>0?Math.min(compPx/strutPx,0.97):0.85;
  var mxp=Ac.x+(Bc.x-Ac.x)*tFrac,myp=Ac.y+(Bc.y-Ac.y)*tFrac;
  ctx.lineCap='butt';
  // Pull both ends back from the ball centres so the strut meets its brackets
  // instead of running through them - at this scale a tube drawn under a ring
  // just reads as a bead threaded on the strut.
  var _sdx=Bc.x-Ac.x,_sdy=Bc.y-Ac.y,_sl=Math.sqrt(_sdx*_sdx+_sdy*_sdy)||1;
  var _ux=_sdx/_sl,_uy=_sdy/_sl,_in=Math.min(6,_sl*0.18);
  var Ai={x:Ac.x+_ux*_in,y:Ac.y+_uy*_in},Bi={x:Bc.x-_ux*_in,y:Bc.y-_uy*_in};
  ctx.strokeStyle=ROD;ctx.lineWidth=4;
  ctx.beginPath();ctx.moveTo(mxp,myp);ctx.lineTo(Bi.x,Bi.y);ctx.stroke();
  ctx.strokeStyle=ACC;ctx.lineWidth=7;
  ctx.beginPath();ctx.moveTo(Ai.x,Ai.y);ctx.lineTo(mxp,myp);ctx.stroke();

  // ── Bracket plates ────────────────────────────────────────────────────────
  // Short ink bars sitting on the surface each bracket screws to, exactly as the
  // design draws B. The old orange plate-with-screw-holes competed with the
  // strut for the eye and made two different things the same colour.
  ctx.lineCap='butt';ctx.strokeStyle=INK;ctx.lineWidth=5;
  if(tp==='box_lid'){
    var bArm=BOFF_A*sc;
    // A's plate lies ON the lid, offset from the ball back toward the lid line.
    // That direction in WORLD space is (sinθ,-cosθ), but canvas y is flipped
    // relative to world y (c2 negates py), so perpY must be +cosθ here. Getting
    // this wrong put the plate on the far side of the ball at every angle.
    var perpX=Math.sin(θ),perpY=Math.cos(θ);
    var aPlX=Ac.x-MX*perpX*bArm,aPlY=Ac.y-perpY*bArm;
    ctx.strokeStyle=ROD;
    ctx.beginPath();ctx.moveTo(aPlX-MX*Math.cos(θ)*14,aPlY+Math.sin(θ)*14);
    ctx.lineTo(aPlX+MX*Math.cos(θ)*14,aPlY-Math.sin(θ)*14);ctx.stroke();
    ctx.strokeStyle=INK;
    ctx.lineWidth=2;ctx.beginPath();ctx.moveTo(aPlX,aPlY);ctx.lineTo(Ac.x,Ac.y);ctx.stroke();
    // B's plate sits flat on the box floor.
    ctx.lineWidth=5;ctx.strokeStyle=ROD;
    ctx.beginPath();ctx.moveTo(Bc.x+MX*16,Bc.y);ctx.lineTo(Bc.x-MX*4,Bc.y);ctx.stroke();
    ctx.strokeStyle=INK;
  } else {
    // Vertical, to lie flat against the vertical jamb it is mounted on.
    ctx.beginPath();ctx.moveTo(Bc.x,Bc.y-11);ctx.lineTo(Bc.x,Bc.y+11);ctx.stroke();
  }

  // ── Pivots ────────────────────────────────────────────────────────────────
  pivot(Ac.x,Ac.y,6.5);
  pivot(Bc.x,Bc.y,6.5);
  pivot(hx,hy,7.5);
  lbl('A · PANEL BRACKET',Ac.x+MX*11,Ac.y-11,INK,9,MX<0?'left':'right');
  lbl('B · WALL BRACKET',Bc.x-MX*11,Bc.y+18,INK,9,MX<0?'right':'left');
  lbl('HINGE PIVOT',hx-MX*13,hy-13,MUTE,9,MX<0?'left':'right');

  // Dimension note, kept from the old figure because it is the only place the
  // bracket distances are stated. Clipped to the canvas so a long one cannot
  // run out past the frame the way it used to.
  ctx.save();ctx.beginPath();ctx.rect(0,ch-22,cw-10,22);ctx.clip();
  if(tp==='box_lid') lbl('A '+Math.round(p.a*1000)+'mm from hinge · B '+Math.round(p.Bx*1000)+'mm fwd, '+Math.round((p.D||0.070)*1000)+'mm down',10,ch-9,MUTE,9);
  else lbl('A '+Math.round(p.a*1000)+'mm from hinge · B set back '+Math.round(Math.abs(p.Bx)*1000)+'mm, '+Math.round(Math.abs(p.By)*1000)+'mm '+(tp==='top_hinge'?'below':'above'),10,ch-9,MUTE,9);
  ctx.restore();
}
// ─── STRUT PREVIEW ────────────────────────────────────────────────────────────
// What the customer is actually buying, shown with the fittings they picked.
// Every URL here was probed for a 200 before being written down: the fitting a
// file shows lives ONLY in its filename, so a guessed name is not a broken
// image, it is the wrong part shown to someone about to order.
// Two gaps, deliberately left visible rather than papered over:
//   - the threaded end has no photograph at all, so the strip hides itself.
//   - only the angled pair has a "with ball studs" render, so that is the only
//     fitting where selecting brackets changes the picture.
var SX_CDN='https://cdn.shopify.com/s/files/1/0776/7477/4628/files/';
var _prevLen=null;
var STRUT_IMG={
  'Standard Plastic Socket 10mm (both ends)':{
    plain:'Standard_20plastic_2010mm_20socket_20shaft__Standard_20plastic_2010mm_20socket_20tube_6978970b-211f-4ac1-8f79-6c16de52f69a.png'},
  'Angled Plastic Socket 10mm (both ends)':{
    plain:'Angled_plastic_socket_10mm_shaft__Angled_plastic_socket_10mm_tube.png',
    studs:'Angled_plastic_socket_10mm_shaft_ball_stud__Angled_plastic_socket_10mm_tube_ball_stud.png'},
  'Small Plastic Socket 10mm (both ends)':{plain:'f6sp_shaft_tube_final.png'},
  'Metal Ball Socket 10mm (both ends)':{plain:'Metal_socket_10mm_shaft__Metal_Socket_10mm_tube.png'},
  'Metal Eye End M8 (both ends)':{plain:'8mm_metal_eye_shaft__8mm_metal_eye_tube.png'}
};
function updStrutImg(){
  var wrap=E('strutprev'),img=E('strutimg'),cap=E('strutcap'),h=E('sxfit');
  if(!wrap||!img||!h)return;
  var rec=STRUT_IMG[h.value];
  if(!rec){wrap.hidden=true;return;}            // no photo for this fitting
  var studs=!!rec.studs;
  wrap.hidden=false;
  img.src=SX_CDN+(studs?rec.studs:rec.plain)+'?width=900';
  img.alt='Struxa gas strut with '+h.value.replace(' (both ends)','')+' at both ends';
  var len=_prevLen?(_prevLen+'mm \u00b7 '):'';
  cap.textContent=len+h.value.replace(' (both ends)','')+' both ends'+(studs?' \u00b7 ball studs shown':'');
}
// ─── GRAPH ────────────────────────────────────────────────────────────────────
var _curView='3d';
function switchView(v){
  _curView=v;
  var m3d=E('m3d'),cgr=E('cgr'),t=E('v3d-title');
  var v3btn=E('v3d-btn'),vgbtn=E('vgr-btn');
  if(v==='3d'){
    if(m3d)m3d.style.display='';if(cgr)cgr.style.display='none';
    if(t)t.textContent='3D PREVIEW — DRAG TO ORBIT';
    if(v3btn){v3btn.style.background='#ff7a00';v3btn.style.color='#fff';v3btn.style.border='none';}
    if(vgbtn){vgbtn.style.background='transparent';vgbtn.style.color='#8a8a86';vgbtn.style.border='1px solid #ddd';}
  } else {
    if(m3d)m3d.style.display='none';if(cgr)cgr.style.display='block';
    if(t)t.textContent='TORQUE GRAPH — PHYSICS VALIDATION';
    if(v3btn){v3btn.style.background='transparent';v3btn.style.color='#8a8a86';v3btn.style.border='1px solid #ddd';}
    if(vgbtn){vgbtn.style.background='#ff7a00';vgbtn.style.color='#fff';vgbtn.style.border='none';}
    drawGraph();
  }
}
function drawGraph(){
  var cv=E('cgr');if(!cv||!P)return;
  var par=cv.parentElement;cv.width=par.clientWidth||500;cv.height=par.clientHeight||350;
  var cw=cv.width,ch=cv.height;
  var ctx=cv.getContext('2d');
  ctx.fillStyle='#fff';ctx.fillRect(0,0,cw,ch);
  var ml=55,mr=16,mt=22,mb=44,pw=cw-ml-mr,ph=ch-mt-mb;
  var p=P,oa=S.oa;
  var gravArr=p.data.map(function(d){return d.tor;});
  var strutArr=p.data.map(function(d){return (p.recF||0)*S.ns*d.arm;});
  var maxT=Math.max.apply(null,gravArr.concat(strutArr))*1.12||10;
  function xP(deg){return ml+deg/oa*pw;}
  function yP(nm){return mt+ph-(nm/maxT)*ph;}
  // Grid
  ctx.strokeStyle='#eee';ctx.lineWidth=1;
  for(var gi=1;gi<5;gi++){var gy=mt+gi*ph/5;ctx.beginPath();ctx.moveTo(ml,gy);ctx.lineTo(ml+pw,gy);ctx.stroke();}
  for(var gd=0;gd<=oa;gd+=10){var gx=xP(gd);ctx.beginPath();ctx.moveTo(gx,mt);ctx.lineTo(gx,mt+ph);ctx.stroke();}
  // Axes
  ctx.strokeStyle='#bbb';ctx.lineWidth=1.5;ctx.beginPath();ctx.moveTo(ml,mt);ctx.lineTo(ml,mt+ph);ctx.lineTo(ml+pw,mt+ph);ctx.stroke();
  // Zones
  var soA=p.soAng||oa;
  ctx.fillStyle='rgba(190,120,110,.07)';ctx.fillRect(xP(0),mt,xP(soA)-xP(0),ph);
  ctx.fillStyle='rgba(120,140,120,.07)';ctx.fillRect(xP(soA),mt,pw-(xP(soA)-xP(0)),ph);
  // Gravity torque (red)
  ctx.strokeStyle='#d03020';ctx.lineWidth=2.5;ctx.lineJoin='round';
  ctx.beginPath();
  p.data.forEach(function(d,i){if(i===0)ctx.moveTo(xP(d.d),yP(gravArr[i]));else ctx.lineTo(xP(d.d),yP(gravArr[i]));});
  ctx.stroke();
  // Strut torque (green)
  ctx.strokeStyle='#1e8040';ctx.lineWidth=2.5;
  ctx.beginPath();
  p.data.forEach(function(d,i){if(i===0)ctx.moveTo(xP(d.d),yP(strutArr[i]));else ctx.lineTo(xP(d.d),yP(strutArr[i]));});
  ctx.stroke();
  // Kick-in line
  if(p.soAng!==null){
    var kx=xP(p.soAng);
    ctx.strokeStyle='#ff7a00';ctx.lineWidth=1.5;ctx.setLineDash([6,4]);
    ctx.beginPath();ctx.moveTo(kx,mt);ctx.lineTo(kx,mt+ph);ctx.stroke();ctx.setLineDash([]);
    ctx.fillStyle='#2e2e34';ctx.font='bold 10px monospace';ctx.textAlign='center';
    ctx.fillText('kicks in '+p.soAng+'°',kx,mt+11);
  }
  // Axis labels
  ctx.fillStyle='#444';ctx.font='bold 9px monospace';ctx.textAlign='right';
  for(var gi2=0;gi2<=5;gi2++){var nmVal=Math.round(maxT*gi2/5);ctx.fillText(nmVal,ml-5,yP(nmVal)+3);}
  ctx.textAlign='center';
  for(var gd2=0;gd2<=oa;gd2+=10){ctx.fillStyle='#444';ctx.fillText(gd2+'°',xP(gd2),mt+ph+13);}
  ctx.save();ctx.translate(13,mt+ph/2);ctx.rotate(-Math.PI/2);ctx.fillStyle='#555';ctx.font='bold 9px monospace';ctx.textAlign='center';ctx.fillText('Torque (Nm)',0,0);ctx.restore();
  ctx.fillStyle='#555';ctx.font='bold 9px monospace';ctx.textAlign='center';ctx.fillText('Angle from closed',ml+pw/2,mt+ph+27);
  ctx.font='bold 9px monospace';ctx.textAlign='right';
  ctx.fillStyle='#d03020';ctx.fillText('← Gravity (closes lid)',ml+pw-4,mt+8);
  ctx.fillStyle='#1e8040';ctx.fillText('← Strut (holds open)',ml+pw-4,mt+21);
  ctx.fillStyle='rgba(190,120,110,.5)';ctx.textAlign='center';ctx.font='bold 8px monospace';ctx.fillText('↓ gravity closes',xP(soA/2),mt+ph-7);
  ctx.fillStyle='rgba(120,140,120,.5)';ctx.fillText('↑ strut holds',xP(soA+(oa-soA)/2),mt+ph-7);
}
// ─── THREE.JS ─────────────────────────────────────────────────────────────────
var rdr=null,sc3=null,cam=null,SO={};
// rad/target auto-scale to whatever's on screen (see fitCam below) unless the person has
// manually zoomed/panned — a fixed camera distance made small boxes render as a few pixels,
// with brackets far too small to see.
// az is negated relative to the original -0.72: Fig.01 and the installation
// diagram now draw the hinge on the right, so the 3D has to be viewed from
// the matching side or the three figures disagree with each other. Mirroring
// the scene itself would invert face winding and wreck the lighting - moving
// the camera is the same picture from the other side.
var orb={az:0.72,pol:0.58,rad:2.2,lx:0,ly:0,drag:false,auto:true,tx:0,ty:0.3,tz:0.2};
function mMat(c,m,r,op){var mt=new THREE.MeshStandardMaterial({color:c,metalness:m||0.5,roughness:r||0.4});if(op!=null){mt.transparent=true;mt.opacity=op;mt.depthWrite=false;mt.side=THREE.DoubleSide;}return mt;}
function mMesh(g,m){var x=new THREE.Mesh(g,m);x.castShadow=x.receiveShadow=true;return x;}
function mEdge(g,c){return new THREE.LineSegments(new THREE.EdgesGeometry(g),new THREE.LineBasicMaterial({color:c}));}
function pCyl(m,p1,p2){var d=new THREE.Vector3().subVectors(p2,p1),l=d.length();if(l<1e-5){m.visible=false;return;}m.visible=true;m.scale.y=l;m.position.copy(p1).addScaledVector(d.normalize(),l/2);m.quaternion.setFromUnitVectors(new THREE.Vector3(0,1,0),d);}
function uCam(){cam.position.set(orb.tx+orb.rad*Math.sin(orb.az)*Math.cos(orb.pol),orb.ty+orb.rad*Math.sin(orb.pol),orb.tz+orb.rad*Math.cos(orb.az)*Math.cos(orb.pol));cam.lookAt(orb.tx,orb.ty,orb.tz);}
// Sizes the orbit distance/target to whatever the current panel's biggest dimension is, so a
// 250mm box and a 2m one both fill the frame instead of using one fixed distance for both.
function fitCam(charSize){
  if(!orb.auto)return;
  // 2.15 rather than 2.6: the auto-frame was leaving a lot of empty floor
  // around the box. Scroll-wheel zoom still overrides this and clears auto.
  orb.rad=Math.max(0.5,Math.min(9,charSize*2.15));
  orb.ty=charSize*0.42;orb.tz=charSize*0.28;orb.tx=0;
  uCam();
}
function i3D(){
  var el=E('m3d');if(!el||!window.THREE||rdr)return;
  rdr=new THREE.WebGLRenderer({antialias:true});rdr.setPixelRatio(Math.min(window.devicePixelRatio||1,2));rdr.shadowMap.enabled=true;rdr.domElement.style.cssText='width:100%;height:100%;display:block;';el.appendChild(rdr.domElement);
  sc3=new THREE.Scene();sc3.background=new THREE.Color(0xffffff);
  cam=new THREE.PerspectiveCamera(38,1,0.01,50);uCam();
  sc3.add(new THREE.AmbientLight(0xffffff,0.72));var sun=new THREE.DirectionalLight(0xffffff,0.95);sun.position.set(4,8,5);sun.castShadow=true;sun.shadow.mapSize.set(1024,1024);sc3.add(sun);
  // Light grid on white, same weight as the ruled grid behind Fig.01 so the
  // two figures read as the same drawing.
  sc3.add(new THREE.GridHelper(10,40,0xd6d6d2,0xececea));
  new ResizeObserver(function(){var w=el.clientWidth,h=el.clientHeight;if(!w||!h)return;rdr.setSize(w,h,false);cam.aspect=w/h;cam.updateProjectionMatrix();}).observe(el);
  var cv3=rdr.domElement;
  cv3.addEventListener('mousedown',function(e){orb.drag=true;orb.lx=e.clientX;orb.ly=e.clientY;});
  cv3.addEventListener('wheel',function(e){orb.auto=false;orb.rad=Math.max(0.15,Math.min(9,orb.rad+e.deltaY*0.003));uCam();e.preventDefault();},{passive:false});
  document.addEventListener('mousemove',function(e){if(!orb.drag)return;orb.az-=(e.clientX-orb.lx)*0.012;orb.pol=Math.max(0.04,Math.min(1.3,orb.pol+(e.clientY-orb.ly)*0.009));orb.lx=e.clientX;orb.ly=e.clientY;uCam();});
  document.addEventListener('mouseup',function(){orb.drag=false;});
  (function lp(){requestAnimationFrame(lp);rdr.render(sc3,cam);})();
}
function bScene(){
  if(!sc3)return;
  var rm=[];sc3.traverse(function(o){if(o.userData.rm)rm.push(o);});rm.forEach(function(o){sc3.remove(o);});
  var p=P,tp=S.type,W=S.wd/1000,T=S.t/1000,L=p.L,BH=p.BH,FT=0.018;
  fitCam(tp==='box_lid'?Math.max(L,BH,W):Math.max(L,W));
  var root=new THREE.Group();root.userData.rm=true;sc3.add(root);
  if(tp==='box_lid'&&S.tilt)root.rotation.x=-(S.tilt*Math.PI/180); // visualise the sloped mount
  var M_BOX=mMat(0xfafaf8,0.05,0.9,0.55),M_LID=mMat(0xff7a00,0.15,0.6,0.92),M_FRM=mMat(0x55555a,0.4,0.6,0.5);
  var M_GLS=mMat(0xdfe4e8,0.1,0.7,0.30);
  var tR=p.tubeR/1000,rR=p.shD===10?0.005:0.004;
  var M_TUB=mMat(0xff7a00,0.8,0.2),M_ROD=mMat(0xffc48a,0.9,0.15);
  // Ink, not white: these were white only so they would show against the old
  // near-black scene, and the real brackets are black anyway.
  var M_A=mMat(0x17171a,0.3,0.45),M_B=mMat(0x17171a,0.3,0.45),M_HNG=mMat(0x3a3a41,0.7,0.3);
  var M_PLA=mMat(0xe6e6e2,0.3,0.5),M_PLB=mMat(0xe6e6e2,0.3,0.5),M_ARM=mMat(0x666677,0.6,0.4);
  M_A.emissive=new THREE.Color(0x111111);M_B.emissive=new THREE.Color(0x111111);
  var hingeY=0,wH=0.010;
  if(tp==='box_lid'){
    hingeY=BH;
    [[W,0.012,L,0,0,L/2],[W,BH,0.012,0,BH/2,0]].forEach(function(r){var g=new THREE.BoxGeometry(r[0],r[1],r[2]);var m=mMesh(g,M_BOX);m.position.set(r[3],r[4],r[5]);root.add(m);root.add((function(){var e=mEdge(g,0x55555a);e.position.set(r[3],r[4],r[5]);return e;})());});
    var sG=new THREE.BoxGeometry(wH*2,BH,L);
    [-W/2,W/2].forEach(function(xw){var sm=mMesh(sG,M_GLS);sm.position.set(xw,BH/2,L/2);root.add(sm);root.add((function(){var e=mEdge(sG,0x8a8a86);e.position.set(xw,BH/2,L/2);return e;})());});
  } else {
    if(tp==='top_hinge')hingeY=L;
    // Frame: head bar at y=L, sill bar at y=0, two side jambs — same fixed rectangle regardless
    // of which end the hinge is on.
    [[W+FT*2,FT,FT,0,L,0],[W+FT*2,FT,FT,0,0,0],[FT,L,FT,-W/2,L/2,0],[FT,L,FT,W/2,L/2,0]].forEach(function(r){var g=new THREE.BoxGeometry(r[0],r[1],r[2]);var m=mMesh(g,M_FRM);m.position.set(r[3],r[4],r[5]);root.add(m);});
    root.add((function(){var wM=mMesh(new THREE.BoxGeometry(W,L,0.008),M_GLS);wM.position.set(0,L/2,-FT/2);return wM;})());
  }
  var hBar=mMesh(new THREE.CylinderGeometry(0.012,0.012,W+0.06,14),M_HNG);hBar.rotation.z=Math.PI/2;hBar.position.set(0,hingeY,0);root.add(hBar);
  // Hinge mount glyph — mirrors the 2D/diagram views so all three previews agree on what each
  // option looks like. Flush needs nothing extra (the barrel sitting right at the corner already
  // reads as flush). Overlay stacks a strap on top of the hinge barrel; inside sets a small leaf
  // plate back into the box (+Z, toward the interior) from the barrel, matching the "pivot sits
  // forward of the true wall" note in calcP.
  if(tp==='box_lid'&&S.hingem&&S.hingem!=='flush'){
    var M_MNT=mMat(0xe8610a,0.6,0.4);
    if(S.hingem==='overlay'){
      var strapG=new THREE.BoxGeometry(Math.min(W*0.5,0.14),0.010,0.026);
      var strapM=mMesh(strapG,M_MNT);strapM.position.set(0,hingeY+0.015,0);root.add(strapM);
    } else if(S.hingem==='inside'){
      var leafG=new THREE.BoxGeometry(Math.min(W*0.5,0.14),0.032,0.006);
      var leafM=mMesh(leafG,M_MNT);leafM.position.set(0,hingeY-0.022,0.016);root.add(leafM);
    }
  }
  var lidGrp=new THREE.Group();lidGrp.position.set(0,hingeY,0);root.add(lidGrp);
  var pL=tp==='box_lid'?new THREE.Vector3(0,T/2,L/2):tp==='top_hinge'?new THREE.Vector3(0,-L/2,0):new THREE.Vector3(0,L/2,0);
  // Box lid: flat panel lying in the X-Z plane, thin in Y (T), long in Z (L, the depth it
  // sweeps over). Window/hatch sash: stands/hangs in the X-Y plane, long in Y (L, its height
  // along the hinge axis), thin in Z (T, the direction it swings open into) — these were both
  // using (W,T,L) before, which rendered the window/hatch sash as a thin horizontal sliver
  // spanning the wrong axis instead of a proper upright panel.
  var pG=tp==='box_lid'?new THREE.BoxGeometry(W,T,L):new THREE.BoxGeometry(W,L,T);
  var pM=mMesh(pG,M_LID);pM.position.copy(pL);lidGrp.add(pM);
  lidGrp.add((function(){var e=mEdge(pG,0x17171a);e.position.copy(pL);return e;})());
  // W/2-wH-tR alone puts the tube's outer surface EXACTLY on the side wall's inner face (zero
  // clearance) — that's what read as "rubbing" on the wall. A further 5mm keeps it visibly
  // clear, the same way B's own ball already stands 5mm+ off the wall it's mounted to.
  var sX=W/2-wH-tR-0.005;
  var sXs=S.ns===2?[-sX,sX]:[0];
  // Every ball on the real bracket sits on a short turned collar before the
  // stud meets the plate. One cylinder each, and it is the detail that makes
  // these read as ball studs rather than spheres floating over a plate.
  // The plates stay rectangular: the real ones are triangular with three bolt
  // holes, but at the size they render here - a few pixels across inside a
  // 500mm box - a chamfered outline and three holes would be noise, not shape.
  function collar(parent,x,y,z,axis){
    var c=mMesh(new THREE.CylinderGeometry(0.0062,0.0062,0.007,12),M_ARM);
    if(axis==='x')c.rotation.z=Math.PI/2; else if(axis==='z')c.rotation.x=Math.PI/2;
    c.position.set(x,y,z);parent.add(c);return c;}
  var mBall=new THREE.SphereGeometry(0.010,12,12);
  var D3=p.D||0.070;
  // A brackets: plate on lid + arm + ball
  sXs.forEach(function(sx){
    var bXp=sx>0?sX:-sX;
    if(tp==='box_lid'){
      var bPos=new THREE.Vector3(bXp,-BOFF_A,p.a);
      var bm=mMesh(mBall,M_A);bm.position.copy(bPos);lidGrp.add(bm);
      var armG=new THREE.CylinderGeometry(0.003,0.003,BOFF_A,8);
      var armM=mMesh(armG,M_ARM);armM.position.set(bXp,-BOFF_A/2,p.a);lidGrp.add(armM);
      collar(lidGrp,bXp,-BOFF_A+0.006,p.a,'y');
      // 30mm across rather than 7mm: the real bracket is a plate you put three
      // bolts through, and a 7mm sliver read as a washer on a stick.
      var plG=new THREE.BoxGeometry(0.030,0.003,0.042);
      var plM=mMesh(plG,M_PLA);plM.position.set(bXp,-0.001,p.a);lidGrp.add(plM);
    } else {
      var lp2=tp==='top_hinge'?new THREE.Vector3(sx,-p.a,0):new THREE.Vector3(sx,p.a,0);
      var bm2=mMesh(new THREE.SphereGeometry(0.014,14,14),M_A);bm2.position.copy(lp2);lidGrp.add(bm2);
      // Mounting plate flush on the sash face (was a bare floating ball before) — a flat plate
      // in the panel's own X-Y face, matching the "no offset arm" physics (A sits directly on
      // the panel surface for these two types, unlike the box lid's 20mm standoff).
      var plGw=new THREE.BoxGeometry(0.036,0.036,0.004);
      var plMw=mMesh(plGw,M_PLA);plMw.position.copy(lp2);lidGrp.add(plMw);
      collar(lidGrp,lp2.x,lp2.y,lp2.z+0.005,'z');
    }
  });
  // B brackets: plate on wall + arm + ball — D below hinge
  var fMts=sXs.map(function(sx){
    var bXp=sx>0?sX:-sX;
    // Use p.By directly (signed) rather than assuming B is always below the hinge —
    // bottom_hinge solves By as a positive offset (B sits above the hinge).
    var pt=new THREE.Vector3(bXp,hingeY+p.By,p.Bx);
    var dbm=mMesh(mBall,M_B);dbm.position.copy(pt);root.add(dbm);
    if(tp==='box_lid'){
      var wallFaceX=sx>0?(W/2-wH-0.001):-(W/2-wH-0.001);
      var pl2G=new THREE.BoxGeometry(0.002,0.042,0.042);
      var pl2M=mMesh(pl2G,M_PLB);pl2M.position.set(wallFaceX,hingeY-D3,p.Bx);root.add(pl2M);
      var armLen=Math.abs(wallFaceX)-Math.abs(bXp);
      if(armLen>0.003){
        var arm2G=new THREE.CylinderGeometry(0.003,0.003,armLen,8);
        var arm2M=mMesh(arm2G,M_ARM);arm2M.rotation.z=Math.PI/2;
        arm2M.position.set((wallFaceX+bXp)/2,hingeY-D3,p.Bx);root.add(arm2M);
        collar(root,bXp+(wallFaceX>0?0.006:-0.006),hingeY-D3,p.Bx,'x');
      }
    } else {
      // Frame-jamb mounting plate for the window/hatch's B ball (previously a bare floating
      // sphere with nothing visibly holding it) — a flat plate facing inward off the jamb.
      var plGf=new THREE.BoxGeometry(0.004,0.036,0.036);
      var plMf=mMesh(plGf,M_PLB);plMf.position.copy(pt);root.add(plMf);
      collar(root,pt.x+(pt.x>0?-0.005:0.005),pt.y,pt.z,'x');
    }
    return pt;
  });
  var sPrs=sXs.map(function(){var body=mMesh(new THREE.CylinderGeometry(tR,tR,1,12),M_TUB);var rod=mMesh(new THREE.CylinderGeometry(rR,rR,1,12),M_ROD);body.castShadow=rod.castShadow=true;root.add(body);root.add(rod);return{body:body,rod:rod};});
  var arcR=0.17,arcPos=[],arcCol=[];
  for(var d=0;d<=S.oa;d++){var θd=d*Math.PI/180,ay3,az3;if(tp==='box_lid'){ay3=hingeY+arcR*Math.sin(θd);az3=arcR*Math.cos(θd);}else if(tp==='top_hinge'){ay3=hingeY-arcR*Math.cos(θd);az3=arcR*Math.sin(θd);}else{ay3=hingeY+arcR*Math.cos(θd);az3=arcR*Math.sin(θd);}arcPos.push(0,ay3,az3);var xso=P.soAng!==null&&d>=P.soAng;arcCol.push(xso?0.1:0.85,xso?0.75:0.15,xso?0.2:0.10);}
  var ag=new THREE.BufferGeometry();ag.setAttribute('position',new THREE.Float32BufferAttribute(arcPos,3));ag.setAttribute('color',new THREE.Float32BufferAttribute(arcCol,3));root.add(new THREE.Line(ag,new THREE.LineBasicMaterial({vertexColors:true})));
  if(P.soAng!==null){var st=P.soAng*Math.PI/180;var sm=mMesh(new THREE.SphereGeometry(0.017,14,14),mMat(0xffffff,0.3,0.5));if(tp==='box_lid')sm.position.set(0,hingeY+arcR*Math.sin(st),arcR*Math.cos(st));else if(tp==='top_hinge')sm.position.set(0,hingeY-arcR*Math.cos(st),arcR*Math.sin(st));else sm.position.set(0,hingeY+arcR*Math.cos(st),arcR*Math.sin(st));root.add(sm);}
  var aDot=mMesh(new THREE.SphereGeometry(0.013,12,12),mMat(0xffffff,0.3,0.5));root.add(aDot);
  SO={lidGrp:lidGrp,sPrs:sPrs,fMts:fMts,sXs:sXs,hingeY:hingeY,arcR:arcR,aDot:aDot,a:p.a,sX:sX};
  aply3D(S.ang);
}
function aply3D(deg){
  if(!SO.lidGrp)return;
  var tp=S.type,θ=deg*Math.PI/180;
  SO.lidGrp.rotation.x=tp==='bottom_hinge'?θ:-θ;
  var cLm=(P&&P.compLen)?P.compLen/1000:0.285;
  SO.sPrs.forEach(function(pr,i){
    var sx=SO.sXs[i],sXv=SO.sX,Ax,Ay,Az;
    if(tp==='box_lid'){
      Ax=sx>0?sXv:-sXv;
      Ay=SO.hingeY+SO.a*Math.sin(θ)-BOFF_A*Math.cos(θ);
      Az=SO.a*Math.cos(θ)+BOFF_A*Math.sin(θ);
    } else if(tp==='top_hinge'){Ax=sx;Ay=SO.hingeY-SO.a*Math.cos(θ);Az=SO.a*Math.sin(θ);}
    else{Ax=sx;Ay=SO.hingeY+SO.a*Math.cos(θ);Az=SO.a*Math.sin(θ);}
    var A=new THREE.Vector3(Ax,Ay,Az),B=SO.fMts[i];
    var AB=new THREE.Vector3().subVectors(B,A),len=AB.length();
    var tf=len>0?Math.min(cLm/len,0.97):0.85;
    var mid=new THREE.Vector3().lerpVectors(A,B,tf);
    pCyl(pr.body,A,mid);pCyl(pr.rod,mid,B);
  });
  if(SO.aDot){if(tp==='box_lid')SO.aDot.position.set(0,SO.hingeY+SO.arcR*Math.sin(θ),SO.arcR*Math.cos(θ));else if(tp==='top_hinge')SO.aDot.position.set(0,SO.hingeY-SO.arcR*Math.cos(θ),SO.arcR*Math.sin(θ));else SO.aDot.position.set(0,SO.hingeY+SO.arcR*Math.cos(θ),SO.arcR*Math.sin(θ));}
}
// ─── ZERO-SHAKE ARCHITECTURE ──────────────────────────────────────────────────
var _dt=null,_rafPending=false;
function recalcDrag(){
  P=calcP();aply3D(S.ang);draw2D();updFast();
  clearTimeout(_dt);
  _dt=setTimeout(function(){
    if(_rafPending)return;_rafPending=true;
    requestAnimationFrame(function(){_rafPending=false;bScene();updSettled();});
  },250);
}
function recalcFull(){
  // "Kicks In At" is not a dial-in target any more — calcP still needs *some* starting angle to
  // size the force against (see sizeForce/solveStruxa, both of which sweep from S.soa), and the
  // only self-consistent value is "whatever angle THIS config actually kicks in at." Solve that
  // by iterating calcP() to a fixed point right here, instead of updating S.soa once per call and
  // trusting next time to correct it — the old single-shot version displayed P computed from
  // whatever S.soa happened to be left over, which could be from a completely different set of
  // dimensions (e.g. Lid Depth changed 500→100→500 left S.soa at the 100mm config's near-zero
  // kick-in, so the 500mm config re-displayed a stronger, wrong strut sized to hold from near 0°
  // instead of its own natural ~18° — confirmed live). A few iterations here converges S.soa (and
  // therefore the displayed P) to the value that's consistent with the CURRENT dimensions alone.
  // Also reseed S.soa to a fixed neutral guess before iterating (rather than iterating from
  // whatever S.soa currently holds) — the required-force sweep [S.soa..oa] is steep enough near
  // 0 degrees (that's where gravity torque peaks) that starting the fixed-point search from a
  // very low leftover S.soa can converge to a DIFFERENT, self-consistent-but-wrong fixed point
  // (a stronger strut whose own natural kick-in is also low) than starting from a normal seed
  // does -- genuine multistability, confirmed live by comparing a fresh load against the same
  // dimensions reached via a detour through a small size and back. Always starting from the same
  // seed makes the result depend only on the current dimensions, not on interaction history.
  S.soa=Math.max(5,Math.min(20,S.oa));
  var Pt=null;
  for(var it=0; it<6; it++){
    Pt=calcP();
    var next=Pt.soAng!=null?Math.max(5,Pt.soAng):S.soa;
    if(Math.abs(next-S.soa)<1){ S.soa=next; break; }
    S.soa=next;
  }
  P=Pt;
  bScene();draw2D();updFast();updSettled();
}
function sAngle(v){S.ang=Math.max(0,Math.min(S.oa,Math.round(v)));sv('ang',S.ang,0,S.oa);var sa=E('s-ang');if(sa)sa.value=S.ang;aply3D(S.ang);draw2D();updFast();}
function stopAnim(){playing=false;clearInterval(aTimer);aTimer=null;var b=E('pb');if(b){b.textContent='▶ Animate';b.classList.add('p');}}
// ─── WIRE ─────────────────────────────────────────────────────────────────────
function wire(id,key,mn,mx,isF,extra){
  var sl=E('s-'+id),nm=E('n-'+id);if(!sl||!nm)return;
  // "Max Open Angle" has a per-panel-type ceiling (TMMAX), which changes whenever the user
  // switches tabs. The tab handler updates the slider's DOM max, but typing a value into the
  // number box used to be validated against the fixed 90 passed in here at wire-up time —
  // letting you type e.g. 85 for a top-hinged window even though the slider itself (and the
  // physics catalog search) only ever supports up to TMMAX[S.type]. Re-derive the true ceiling
  // for 'oa' on every update instead of trusting the closed-over mx.
  function effMax(){ return key==='oa' ? (TMMAX[S.type]||mx) : mx; }
  function clamp(raw){var v=isF?parseFloat(raw):parseInt(raw,10);return isNaN(v)?S[key]:Math.max(mn,Math.min(effMax(),v));}
  function upd(raw,full){
    var v=clamp(raw);S[key]=v;sl.value=v;nm.value=isF?v.toFixed(1):v;sv(id,v,mn,effMax());
    if(key==='oa'){sl.max=effMax();nm.max=effMax();}
    if(extra)extra(v);
    if(key==='oa'){
      S.ang=v;sv('ang',v,0,v);var sa=E('s-ang');if(sa){sa.max=v;sa.value=v;}
      // No more soa slider to keep in range, but S.soa still needs to stay inside the new
      // [0,oa] window the sizeForce loop actually sweeps over.
      var mx2=Math.max(10,v-5);if(S.soa>mx2)S.soa=mx2;
    } else if(key!=='ang') S.ang=0;
    if(full)recalcFull();else recalcDrag();
  }
  sl.addEventListener('input',function(){upd(this.value,false);});
  sl.addEventListener('change',function(){upd(this.value,true);});
  nm.addEventListener('change',function(){upd(this.value,true);});
  nm.addEventListener('keydown',function(e){if(e.key==='Enter')upd(this.value,true);});
  sv(id,S[key],mn,effMax());
}
// ─── INIT ─────────────────────────────────────────────────────────────────────
function init(){
  if(init._done||!E('gsc'))return;init._done=true;
  wire('w','w',0.5,300,true,function(v){if(v>5&&S.ns===1){S.ns=2;E('nb1').classList.remove('on');E('nb2').classList.add('on');}});
  wire('l','l',100,2000,false,null);wire('wd','wd',100,2000,false,null);wire('t','t',3,150,false,null);
  wire('bh','bh',80,1500,false,null);wire('oa','oa',30,90,false,null);
  wire('tilt','tilt',-30,30,false,null);
  E('s-ang').addEventListener('input',function(){stopAnim();sAngle(this.value);});
  // The hint under the tabs was written into the markup once and never
  // touched again, so choosing Window left the box-lid sentence underneath it.
  var typeHints={
    box_lid:'Top-hinged lid lifting up and back over the box.',
    top_hinge:'Top-hinged window or flap swinging up and out from the frame.',
    // Struxa does not build a bottom-hinged hatch, so there is no tab for it.
    // The solver still handles the case; this stays so the type is not
    // half-wired if it is ever offered.
    bottom_hinge:'Bottom-hinged hatch tilting out and down from the frame.'
  };
  ['box_lid','top_hinge','bottom_hinge'].forEach(function(t){
    var b=E('t-'+t);if(!b)return;
    b.addEventListener('click',function(){
      S.type=t;S.oa=TMMAX[t];S.ang=0;
      var th=E('typehint');if(th&&typeHints[t])th.textContent=typeHints[t];
      ['box_lid','top_hinge','bottom_hinge'].forEach(function(id){var btn=E('t-'+id);if(btn)btn.classList.toggle('on',id===t);});
      var sl=E('s-oa'),nm=E('n-oa');if(sl){sl.max=TMMAX[t];sl.value=TMMAX[t];}if(nm)nm.value=TMMAX[t];sv('oa',TMMAX[t],30,TMMAX[t]);
      var tiltRow=E('tilt-row');if(tiltRow)tiltRow.style.display=t==='box_lid'?'':'none';
      var hingeRow=E('hinge-row');if(hingeRow)hingeRow.style.display=t==='box_lid'?'':'none';
      orb.auto=true; // panel shape changes completely between types — always re-frame the camera
      recalcFull();
    });
  });
  var hingeNotes={
    flush:'Pivot assumed at the wall\'s inner top corner — this is the default the rest of the tool has always used.',
    overlay:'Barrel sits essentially at the same inner corner horizontally as flush — doesn\'t change the numbers below.',
    inside:'Pivot sits forward of the true wall face by about one panel thickness — "B forward from back wall" is adjusted to match. Doesn\'t change the recommended strut or kick-in angle — those only depend on the lid\'s geometry relative to the pivot, not on where the wall physically is.'
  };
  ['flush','overlay','inside'].forEach(function(hm){
    var b=E('hm-'+hm);if(!b)return;
    b.addEventListener('click',function(){
      S.hingem=hm;
      ['flush','overlay','inside'].forEach(function(k){
        var o=E('hm-'+k);if(o)o.classList.toggle('on',k===hm);});
      var hn=E('hinge-note');if(hn)hn.textContent=hingeNotes[hm]||'';
      recalcFull();
    });
  });
  // End fitting tiles write through to the hidden #sxfit, then recalc so the
  // cart link picks up the new property value.
  [].forEach.call(document.querySelectorAll('#gsc .fitt'),function(b){
    b.addEventListener('click',function(){
      var h=E('sxfit');if(h)h.value=b.getAttribute('data-fit')||h.value;
      updStrutImg();
      [].forEach.call(document.querySelectorAll('#gsc .fitt'),function(o){
        o.classList.toggle('on',o===b);});
      recalcFull();
    });
  });
  E('nb1').addEventListener('click',function(){if(S.w>5)return;S.ns=1;S.ang=0;E('nb1').classList.add('on');E('nb2').classList.remove('on');recalcFull();});
  E('nb2').addEventListener('click',function(){S.ns=2;S.ang=0;E('nb1').classList.remove('on');E('nb2').classList.add('on');recalcFull();});
  E('pb').addEventListener('click',function(){playing=!playing;this.textContent=playing?'⏸ Pause':'▶ Animate';this.classList.toggle('p',!playing);if(playing){aTimer=setInterval(function(){S.ang+=aDir;if(S.ang>=S.oa){aDir=-1;S.ang=S.oa;}if(S.ang<=0){aDir=1;S.ang=0;}sAngle(S.ang);},20);}else clearInterval(aTimer);});
  E('ob').addEventListener('click',function(){stopAnim();var ti=setInterval(function(){S.ang++;sAngle(S.ang);if(S.ang>=S.oa)clearInterval(ti);},20);});
  E('cl').addEventListener('click',function(){stopAnim();var ti=setInterval(function(){S.ang--;sAngle(S.ang);if(S.ang<=0)clearInterval(ti);},20);});
  E('rs').addEventListener('click',function(){stopAnim();sAngle(0);});
  E('qdn').addEventListener('click',function(){if(pQty>S.ns)pQty--;updProd();});
  E('qup').addEventListener('click',function(){pQty++;updProd();});
  var svBtn=E('save-diag');if(svBtn)svBtn.addEventListener('click',saveDiagram);
  var prBtn=E('print-sheet');if(prBtn)prBtn.addEventListener('click',printFittingSheet);
  new ResizeObserver(function(){draw2D();if(_curView==='gr')drawGraph();}).observe(E('c2d').parentElement);
  // The installation diagram now stretches to fill the center column's height (matching the
  // right-hand Order column), so redraw it whenever that box's actual size changes — window
  // resize, or the right column growing/shrinking as its content updates.
  new ResizeObserver(function(){drawDiag();}).observe(E('dsvg').parentElement);
  i3D();recalcFull();
}
init._done=false;
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
else init();
window.addEventListener('load',init);
})();
